import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.error.cause.js";
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import Tool, { addTabTitle, handleLocalStorage, returnSourceType } from '@/assets/js/utils.js';
import AgoraClient from '@/assets/js/rtc-client-ng';
import i18n from '@/lang/index.js';
import { controlCamera, controlAudio, changeBehaviorStatus, controlDeviceBehavior, controlDevicePublish, controlDeviceAudioOrVideo } from '@/assets/js/attendUser.js';
import VolumeBar from '@/assets/js/volumeBar.js';
const nodeUrl = require('url');
export default {
  data() {
    return {
      illegalPartyCode: '',
      osLevelmicMuted: false,
      showMicMutedInfo: {
        show: false,
        title: 'micMutedInfo.title',
        hideSave: true,
        hideCancel: true,
        showGotIt: true,
        gotIt: 'micMutedInfo.ignore'
      },
      checkRemindMe: false,
      lastApiCall: 0,
      controlTalkBtnTime: 0,
      dealyExecuteTimeL: 500,
      // 延迟执行的时间默认为 500 ms
      liveAndLazyAudioInfo: {
        title: 'common.lazyAudioOpen',
        save: 'common.gotIt',
        show: false
      },
      aiPolicyInfo: {
        title: 'aiSpeech.aiPolicyTitle',
        save: 'common.gotIt',
        show: false,
        showRemindMe: true
      },
      anywhereSettingShowMap: {},
      anyWhereRtilCodeObj: {},
      anyWhereVideoAudioInfo: null,
      anyWherePeerIds: {},
      isAnyWhere: {},
      anyWherePlatForms: {},
      anyWhereSettings: {},
      anyWhereInfo: {
        show: false,
        rtilCode: ''
      },
      langArray: [{
        label: 'Auto',
        val: ''
      }, {
        label: 'English',
        val: 'English'
      }, {
        label: 'Chinese Simplified',
        val: '中文简体'
      }, {
        label: 'Chinese Traditional',
        val: '中文繁體'
      }, {
        label: 'Korean',
        val: 'Korean'
      }, {
        label: 'Japanese',
        val: 'Japanese'
      }, {
        label: 'Spanish',
        val: 'Spanish'
      }, {
        label: 'Portugues',
        val: 'Portugues'
      }, {
        label: 'French',
        val: 'French'
      }],
      translateInto: '',
      showTranslate: false,
      showUnread: false,
      audioLevel: true,
      muteAmAudio: false,
      showAISpeech: false,
      final_transcript: '',
      interim_transcript: '',
      pipHostVolume: '',
      showShareScreen: false,
      hostControlPipRtilCode: {},
      CameraTips: {
        hideSave: false,
        hideCancel: false,
        showGotIt: false,
        gotIt: 'galleryParticipant.gotIt',
        title: 'galleryParticipant.cameraTips',
        content: '',
        cancel: 'galleryParticipant.deny',
        save: 'galleryParticipant.admit',
        show: false
      },
      asParticipants: false,
      asParticipant: true,
      containerWidth: '',
      containerHeight: '',
      fullRotate: false,
      devicePlatform: {},
      devicePeerIdInfo: {},
      degreeHost: {},
      deviceType: {},
      allRtilList: [],
      rtilCodeList: [],
      shareInitiator: '',
      shareList: {},
      rtilCodeByShare: {},
      devicesInfo: {
        cameraList: [],
        microphoneList: [],
        cameraId: '',
        microphoneId: ''
      },
      voipInfo: {},
      loadChatBox: true,
      controlMuteInfo: {},
      showChatMessage: false,
      talkBackInfo: {},
      needStartVoip: false,
      talkbackStatus: false,
      batchMovePartyInfo: {
        show: false,
        rtilCodes: []
      },
      movePartyInfo: {
        show: false
      },
      allRList: {},
      rtilStatusTimer: null,
      rtilStatusObj: {},
      deviceStatusObj: {},
      livePeerMap: {},
      allRtilCodeByAccountId: {},
      allAccountIdByRtilCode: {},
      rtilCodeLiveR: {},
      channels: {},
      rtc: null,
      selectPGMRid: '',
      partyCode: 0,
      videoInfo: {},
      noCameras: false,
      voipSourceIdList: [],
      sourceIdKeyList: [],
      voiceList: {},
      rtilCode: '',
      updataInfoTimer: null,
      wsInfoArray: {},
      socket: null,
      value: true,
      origin: '',
      shareClient: null,
      isallScrren: false,
      timer: null,
      offlineTimes: 0,
      sourceIdList: [],
      updataStatusTimer: null,
      PartyLineRequest: null,
      MeInfo: {},
      MeInfos: {},
      showCrewBtn: true,
      setNameInfo: {
        show: false
      },
      Vfb: {
        show: false
      },
      mainWindowInfo: {},
      vfbSourceType: '',
      userInfo: {},
      behaviorInfo: {},
      joinParam: {},
      lastPgm: {
        id: '',
        type: ''
      },
      setTimer: null,
      wsPageSTimer: null,
      drawer: false,
      outputRtilCode: '',
      videoProfile: '',
      startLoading: false,
      stopLoading: false,
      rtcLoaded: false,
      setTagName: {
        show: false,
        tagName: ''
      },
      tagNameInfo: {},
      encoderInfo: {
        visible: false,
        data: [],
        maxNumber: 1
      },
      ChannelMode: {
        '-1': 'UNKNOWN',
        0: 'COMMON',
        1: 'GALLERY',
        2: 'CONFERENCE',
        3: 'EXTERNAL',
        4: 'SCENE',
        7: 'CANVAS',
        8: 'SECTION',
        9: 'COMMENTATOR_PARENT',
        12: 'COMMENTATOR',
        13: 'KIOSK'
      },
      allPartyMembers: [],
      shareRtilCode: '',
      remoteNetWorks: {},
      lowNetworkTime: 0,
      lowNetwork: false,
      iconList: ['camera', 'mic', 'speaker', 'share', 'chat'],
      startHearSelf: false,
      hearSelf: true,
      leftRightShareRtilCode: '',
      initAudioOnlyPopup: true,
      coHostLimit: {
        show: false,
        title: 'personalInfo.Permission',
        save: 'personalInfo.accept',
        cancel: 'personalInfo.decline',
        info: {}
      },
      repeatInfo: {
        show: false,
        title: 'common.repeatJoin',
        save: 'authorizeOperation.ok'
      },
      coHostInfo: {
        show: false,
        title: 'personalInfo.Permission',
        save: 'personalInfo.accept',
        cancel: 'personalInfo.decline',
        info: {}
      },
      collaborateInfo: {
        show: false,
        title: 'personalInfo.Permission',
        save: 'personalInfo.accept',
        cancel: 'personalInfo.decline',
        info: {}
      },
      controlMediaInfo: {
        show: false,
        title: 'common.operatPermission',
        save: 'galleryParticipant.admit',
        cancel: 'galleryParticipant.deny',
        info: {}
      },
      deviceDetailInfo: {
        show: false,
        title: 'common.details',
        save: 'authorizeOperation.ok'
      },
      detailObj: {},
      myselfMuteInfo: {},
      hadOpenWebCloud: false,
      otherMediaInfo: {},
      allowedList: {},
      canvas: {},
      ctx: {},
      initMirror: true,
      canvasVideoTimer: null,
      fullScreenInfo: {},
      blob: null,
      recordVideo: null,
      chunks: [],
      lastPrivatePositionInfo: [],
      packPageParams: {
        online: true,
        living: true,
        condition: '',
        pageNum: 1,
        pageSize: 20
      },
      localVolume: 0,
      summary: '',
      keepInCurrentLine: true,
      speechTimer: null,
      rtilCodeKeyTypeVal: {},
      sttRtilCode: '',
      hasPushToTalk: false,
      needReMute: false,
      videoCanvasWidth: '',
      resizeTimer: null,
      videoCanvasColumn: '',
      sendPrivateToMeRtilcodes: [],
      leftRightRtilCode: '',
      showZoomClass: false,
      sendEmailInfo: {
        title: 'common.sendSetting',
        save: 'commonPartyHost.topContent.send',
        hideSave: true,
        show: false
      },
      emailList: [{
        title: 'sendByEmail',
        value: ''
      }, {
        title: 'sendBySlack',
        value: ''
      }],
      showSavingTips: false,
      saveEmailSuccess: false,
      sttHistoryList: [],
      starting: false
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      currentPartyInfo: state => state.currentPartyInfo,
      loginInfo: state => state.loginInfo,
      Config: state => state.config,
      resolutionRange: state => state.resolutionRange
    }),
    returnSavingEmailText() {
      let _str = this.$t('aiSpeech.emailSaving');
      if (this.showSavingTips && this.saveEmailSuccess) {
        _str = this.$t('aiSpeech.emailSaved');
      }
      return _str;
    },
    formattedText() {
      return this.State.summaryInfo.contentText.replace(/\n/g, '<br>');
    },
    returnVideoClass() {
      let _str = '';
      if (this.degreeHost[this.MeInfo.id] == 0) {
        _str += 'rotate0';
      } else if (this.degreeHost[this.MeInfo.id] == 90) {
        if (this.fullRotate && this.State.isVertical) {
          _str += 'rotateFull90';
        } else {
          _str += 'rotate90';
        }
      } else if (this.degreeHost[this.MeInfo.id] == 180) {
        _str += 'rotate180';
      } else if (this.degreeHost[this.MeInfo.id] == 270) {
        if (this.fullRotate && this.State.isVertical) {
          _str += 'rotateFull270';
        } else {
          _str += 'rotate270';
        }
      }
      return _str;
    },
    isShare() {
      let flag = false;
      Object.keys(this.shareList).forEach(key => {
        if (!flag && this.shareList[key] == this.userInfo.rtilCode) {
          flag = true;
        }
      });
      return flag;
    }
  },
  filters: {
    showItemName(name) {
      if (!name) return '';
      if (name === 'Producer PGM' || name === 'producerPgm') {
        return i18n.t('mainWindow.producerPgm');
      } else if (name === 'Receiver VFB' || name === 'receiverVF') {
        return i18n.t('mainWindow.receiverVF');
      } else {
        return name;
      }
    }
  },
  watch: {
    'State.fullScreen': {
      handler: function (val) {
        if (val) {
          this.fullRotate = true;
        } else {
          this.fullRotate = false;
        }
      }
    },
    'State.batchMoveParticipate': function (val) {
      this.batchMovePartyInfo.show = val;
      if (!val) {
        this.batchMovePartyInfo.rtilCodes = [];
      }
    },
    'State.showAISpeech': {
      handler: function (newValue) {
        const aiPolicyNotShown = localStorage.getItem(`aiPolicyNotShown_${handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime()}`) == 'true';
        if (newValue && this.State.config.features.stt && !aiPolicyNotShown) {
          this.aiPolicyInfo.show = true;
        }
      },
      immediate: true
    },
    talkbackStatus: {
      handler: function (newValue) {
        if (newValue && this.starting) {
          this.liveAndLazyAudioInfo.show = true;
        }
      },
      immediate: true
    },
    $route: function (to, from) {
      let partyCode = from.query.id;
      // 检查 partyCode 中是否包含字母
      const hasLetters = /[a-zA-Z]/.test(partyCode);
      const illegalPartyCode = hasLetters ? partyCode : '';
      if (partyCode) partyCode = partyCode.replace(/[^0-9]/ig, ''); // 过滤掉非数字字符
      if (partyCode.length > 20 || partyCode.length < 9) {
        this.$message.error(this.$t('common.invalidPartyIdText'));
        return;
      }
      const params = {
        partyCode,
        module: 'leaveParty',
        msg: {
          realPartyCode: partyCode,
          rtilCode: handleLocalStorage('get', 'rtilCode')
        }
      };
      if (illegalPartyCode) {
        params._illegalPartyCode = illegalPartyCode;
      }
      if (!params.partyCode || !params.msg.rtilCode) return;
      this.axios.post('/partyline-backend/party/noLogin/command?key=112630', params);
    },
    rtilCodeList() {
      this.$nextTick(() => {
        this.changeLayout();
      });
    },
    outputRtilCode() {
      this.$nextTick(() => {
        this.changeLayout();
      });
    },
    leftRightRtilCode(val, oldVal) {
      this.$nextTick(() => {
        var _this$rtc, _this$rtc$_localVideo;
        this.changeLayout();
        if (val && this.$refs.leftRight) {
          var _this$$refs$leftRight;
          (_this$$refs$leftRight = this.$refs.leftRight) === null || _this$$refs$leftRight === void 0 ? void 0 : _this$$refs$leftRight.changeFullScreenVal(!!val);
        }
        (_this$rtc = this.rtc) === null || _this$rtc === void 0 ? void 0 : (_this$rtc$_localVideo = _this$rtc._localVideoTrack) === null || _this$rtc$_localVideo === void 0 ? void 0 : _this$rtc$_localVideo.play('local_stream');
        if (oldVal && oldVal == this.outputRtilCode && this.$refs[`remoteSingleSource${this.outputRtilCode}`] && this.$refs[`remoteSingleSource${this.outputRtilCode}`][0]) {
          this.$refs[`remoteSingleSource${this.outputRtilCode}`][0].changeFullScreenVal(false);
        }
      });
    }
  },
  created() {
    /**
     * @params 重构新加代码开始
     */
    const URL = nodeUrl.parse(location.href, true);
    this.partyCode = URL.query.id;
    // 检查 partyCode 中是否包含字母
    const hasLetters = /[a-zA-Z]/.test(this.partyCode);
    const illegalPartyCode = hasLetters ? this.partyCode : '';
    if (this.partyCode) this.partyCode = this.partyCode.replace(/[^0-9]/ig, ''); // 过滤掉非数字字符
    if (this.partyCode.length > 20 || this.partyCode.length < 9) {
      this.$message.error(this.$t('common.invalidPartyIdText'));
      return;
    }
    this.getPartyInfo(this.partyCode, illegalPartyCode);
    window.addEventListener('keydown', this.listenerKeyDown);
    window.addEventListener('keyup', this.listenerKeyUp);
    /**
     * @params 重构新加代码结束
     */
    Bus.$on('startStt', v => {
      const {
        outputRtilCode
      } = v;
      this.showAISpeech = true;
      this.State.showAISpeech = true;
      this.sttRtilCode = outputRtilCode;
      this.rtilCodeList = this.rtilCodeList.filter(v => v != outputRtilCode);
      this.allPartyMembers = this.allPartyMembers.filter(v => v != outputRtilCode);
      this.State.allRtilCodes = this.State.allRtilCodes.filter(v => v != outputRtilCode);
    });
    Bus.$on('stopStt', v => {
      this.sttRtilCode = '';
      this.showAISpeech = false;
      this.State.showAISpeech = false;
    });
    Bus.$on('setPartyTitle', v => {
      document.title = this.$t('common.partyTitle', {
        name: v.title
      });
    });
    Bus.$on('mainWindowSetting', val => {
      if (!this.State.isMute) {
        this.pipHostVolume = val.pipVolume;
      }
      // this.$message.success(this.$t('setting.adjustedVloume'))
    });

    Bus.$on('controlBehavior', async v => {
      const {
        rtilCode,
        behavior,
        senderRtilCode
      } = v;
      const {
        key,
        value
      } = behavior;
      const changeToBooleanVal = value === 'true';
      if (rtilCode == this.userInfo.rtilCode) {
        if (key == 'camera') {
          // 避免之后多host控制与会者device，用于记录操作host的rtilCode，以最后一次操作的host为准
          this.$set(this.hostControlPipRtilCode, 'camera', senderRtilCode);
          if (!changeToBooleanVal) {
            controlCamera(this.rtc, this.devicesInfo, changeToBooleanVal);
            controlDeviceBehavior({
              senderRtilCode: this.userInfo.rtilCode,
              type: 'camera',
              value: false,
              partyCode: this.userInfo.realPartyCode,
              toRtilCode: this.userInfo.rtilCode,
              origin: 'commonPartyHost'
            });
            this.$message.warning(this.$t('commonFunction.hasCameraOff'));
          } else {
            this.CameraTips.hideSave = false;
            this.CameraTips.hideCancel = false;
            this.CameraTips.showGotIt = false;
            this.CameraTips.show = true;
            this.CameraTips.content = `<div class="end">${this.$t('galleryParticipant.cameraTipCon')}</div>`;
          }
        }
        if (key == 'mic') {
          // 避免之后多host控制与会者device，用于记录操作host的rtilCode，以最后一次操作的host为准
          this.$set(this.hostControlPipRtilCode, 'mic', senderRtilCode);
          let operationResult = 'success';
          if (this.rtc._localAudioTrack) {
            const type = changeToBooleanVal ? 'publish' : 'unpublish';
            operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
          } else {
            // 初始化的时候没有本地音频轨道，需要重新获取
            controlAudio(this.rtc, this.devicesInfo, changeToBooleanVal, result => {
              if (result != 'failed' && changeToBooleanVal) {
                // 为了可以听见自己声音的功能添加的
                if (this.State.startHearSelf && this.hearSelf && this.rtc._localAudioTrack) {
                  this.rtc.play(this.rtc._localAudioTrack, '', {
                    type: 'audio'
                  });
                }
              } else {
                operationResult = 'failed';
              }
            });
          }
          if (operationResult === 'success') {
            controlDeviceBehavior({
              senderRtilCode: this.userInfo.rtilCode,
              type: 'mic',
              value: changeToBooleanVal,
              partyCode: this.userInfo.realPartyCode,
              toRtilCode: this.userInfo.rtilCode,
              origin: 'commonPartyHost'
            });
          }
          this.$message.warning(changeToBooleanVal ? this.$t('remainWords.hostHasMicrophoneOn') : this.$t('commonFunction.hasMicrophoneOff'));
        }
      }
      if (key == 'nickName' && this.behaviorInfo[rtilCode]) {
        this.behaviorInfo[rtilCode] = value;
      }
    });
    // 移动host或co-host到其他会议
    Bus.$off('moveParticipants');
    Bus.$on('moveParticipants', val => {
      if (this.userInfo.joinCode != val.originCode) return; // 如果在move过程中，这个host或co-host到了别的party。则move的命令此时不作处理
      // 若被移动的co-host或host在目标会议中无co-host权限，则跳转与会者页面
      // 若被移动的co-host或host在目标会议中有co-host权限，则进入host页面
      val.rtilCodes.forEach(v => {
        if (v == this.userInfo.rtilCode) {
          this.$router.push({
            name: 'participate',
            query: {
              join_id: val.targetCode,
              moveParticipants: true
            }
          });
        }
      });
    });
    Bus.$on('flipVideo', v => {
      // 与会者getList(与会者、anywhere)
      this.$set(this.degreeHost, v.rtilCode, v.degree);
    });
    // 创建获取device的websocket
    this.createdWebsocket(this.State.config);
    this.getRList();
    // 谷歌分析
    gtag('event', 'pageView-Common party', {
      event_category: 'pageView',
      event_label: '会议模块',
      value: 'Common party'
    });
    // 移除co-host
    Bus.$on('removeParticipant', v => {
      if (v.rtilCode === this.userInfo.rtilCode) {
        this.$router.push({
          name: 'remove'
        });
        this.State.hadInvitedCoHostList = this.State.hadInvitedCoHostList.filter(item => {
          return item.id != v.id;
        });
      } else if (v.rtilCode == this.leftRightRtilCode) {
        this.leftRightRtilCode = '';
        this.$nextTick(() => {
          this.changeLayout();
        });
      }
    });
    Bus.$on('viewPositionV2', result => {
      const rtilCodes = result.total;
      this.allRtilList = rtilCodes;
      this.handleRtilCodeList();
      this.cancelPrivate(result);
      rtilCodes.forEach(rtilCode => {
        const haveName = this.behaviorInfo[rtilCode];
        if (!haveName) {
          this.getNickName(rtilCode);
        }
      });
    });
    Bus.$off('cancelTalkBack');
    Bus.$on('cancelTalkBack', val => {
      if (val.partyCode == this.userInfo.joinCode) {
        this.talkbackStatus = false;
        this.State.talkbackStatus = false;
      }
      this.talkBackInfo = {};
    });
    Bus.$off('setTalkBack');
    Bus.$on('setTalkBack', val => {
      if (val.partyCode == this.userInfo.joinCode) {
        this.talkbackStatus = true;
        this.State.talkbackStatus = true;
      }
    });
    Bus.$off('cancelParticipantTalkBack');
    Bus.$on('cancelParticipantTalkBack', val => {
      const {
        rtilCode
      } = val;
      this.$set(this.talkBackInfo, rtilCode, false);
      this.$set(this.controlMuteInfo, rtilCode, '');
      if (rtilCode == this.userInfo.rtilCode) {
        this.$message.success(this.$t('commonSetting.offLocalLazyAUdioTip'));
      }
    });
    Bus.$off('setParticipantTalkBack');
    Bus.$on('setParticipantTalkBack', val => {
      const {
        rtilCode
      } = val;
      this.$set(this.talkBackInfo, rtilCode, true);
      if (rtilCode == this.userInfo.rtilCode) {
        this.$message.success(this.$t('commonSetting.onLocalLazyAUdioTip'));
      } else {
        this.$set(this.controlMuteInfo, rtilCode, true);
      }
    });
    Bus.$off('chatMessage');
    Bus.$on('chatMessage', v => {
      var _this$$refs$footDiv;
      this.showUnread = v.showUnread;
      if (v.status) {
        this.loadChatBox = true;
      }
      this.showChatMessage = v.status;
      this.showAISpeech = false;
      (_this$$refs$footDiv = this.$refs.footDiv) === null || _this$$refs$footDiv === void 0 ? void 0 : _this$$refs$footDiv.changeVoiceValue(false);
    });
    Bus.$on('volumeList', volumeList => {
      volumeList.forEach(volume => {
        this.$set(this.voiceList, volume.uid, volume);
      });
    });
    Bus.$on('intercom', v => {
      const {
        partyCode,
        rtilCode,
        receiveRtilCode,
        startRtilCode,
        msg,
        value
      } = v;
      const {
        ack
      } = msg;
      if (value === 'true') {
        if (this.State.startPrivateInfo[rtilCode]) {
          var _this$State$startPriv;
          if (!((_this$State$startPriv = this.State.startPrivateInfo[rtilCode]) !== null && _this$State$startPriv !== void 0 && _this$State$startPriv.includes(receiveRtilCode))) this.State.startPrivateInfo[rtilCode].push(receiveRtilCode);
        } else {
          this.$set(this.State.startPrivateInfo, rtilCode, [receiveRtilCode]);
        }
        if (startRtilCode && startRtilCode == this.userInfo.rtilCode && !this.State.localSendPrivateArray.includes(receiveRtilCode)) {
          this.State.localSendPrivateArray.push(receiveRtilCode);
        }
        if (receiveRtilCode == this.rtilCode) {
          if (!this.sendPrivateToMeRtilcodes.includes(startRtilCode)) this.sendPrivateToMeRtilcodes.push(startRtilCode);
          const nickName = this.behaviorInfo[rtilCode];
          if (startRtilCode && ack === 0) {
            this.$message({
              type: 'success',
              message: this.$t('commonPartyHost.receiveTwoWayPrivate', {
                nickName
              })
            });
            this.privateConversationFn({
              rtilCode: rtilCode,
              channel: partyCode,
              type: 'startPrivateConversation',
              ack: 1
            });
          } else {
            if (ack === 0) {
              this.$message({
                type: 'success',
                message: this.$t('commonPartyHost.receiveOneWayPrivate', {
                  nickName
                })
              });
            }
          }
        }
      } else {
        if (startRtilCode && startRtilCode == this.userInfo.rtilCode && this.State.localSendPrivateArray.includes(receiveRtilCode)) {
          this.State.localSendPrivateArray = this.State.localSendPrivateArray.filter(rtilCode => rtilCode != receiveRtilCode);
        }
        if (this.State.startPrivateInfo[rtilCode]) {
          this.State.startPrivateInfo[rtilCode] = this.State.startPrivateInfo[rtilCode].filter(rtilCode => {
            return rtilCode != receiveRtilCode;
          });
          if (receiveRtilCode === this.rtilCode) {
            const nickName = this.behaviorInfo[rtilCode];
            // 如果是私聊发起者取消私聊，那么接收者也要取消私聊
            if (this.sendPrivateToMeRtilcodes.includes(rtilCode) && ack === 0) {
              this.sendPrivateToMeRtilcodes = this.sendPrivateToMeRtilcodes.filter(rtilCodes => rtilCodes != rtilCode);
              this.privateConversationFn({
                rtilCode: rtilCode,
                channel: partyCode,
                type: 'cancelPrivateConversation',
                ack: 1
              });
              this.$message({
                type: 'success',
                message: this.$t('commonPartyHost.cancelTwoWayPrivate', {
                  nickName
                })
              });
            } else {
              if (ack === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('commonPartyHost.cancelOneWayPrivate', {
                    nickName
                  })
                });
              } else {
                this.$message({
                  type: 'success',
                  message: this.$t('commonPartyHost.endTwoWayPrivate', {
                    nickName
                  })
                });
              }
            }
          }
          // 删除发起者数据
          if (this.State.startPrivateInfo[rtilCode] && !this.State.startPrivateInfo[rtilCode].length) this.$delete(this.State.startPrivateInfo, rtilCode);
        }
      }
    });
    Bus.$on('checkAll', data => {
      this.isallScrren = true;
      this.shareInitiator = data.shareInitiator;
    });
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          var _val$value;
          if (!((_val$value = val.value) !== null && _val$value !== void 0 && _val$value.includes('_Screen_Share'))) {
            this.$set(this.behaviorInfo, val.mark, val.value);
            this.$set(this.State.globalNameInfo, val.mark, val.value);
          }
          Object.keys(this.shareList).forEach(share => {
            if (this.shareList[share] == val.mark) {
              var _val$value2;
              if (!((_val$value2 = val.value) !== null && _val$value2 !== void 0 && _val$value2.includes('_Screen_Share'))) {
                this.$set(this.behaviorInfo, share, val.value);
                this.$set(this.State.globalNameInfo, share, val.value);
              }
              this.saveShareName({
                rtilCode: share
              });
            }
          });
        }
        if (val.key == 'tagName') {
          this.$set(this.tagNameInfo, val.mark, val.value);
        }
        if (this.anyWhereSettings[val.mark] && val.key in this.anyWhereSettings[val.mark]) {
          if (val.key === 'whiteBalance') {
            const parsedValue = JSON.parse(val.value);
            this.$set(this.anyWhereSettings[val.mark], val.key, parsedValue);
          } else {
            // Directly set the value for other keys
            this.$set(this.anyWhereSettings[val.mark], val.key, val.value);
          }
        }
        if (val.key == 'voiceCommand') {
          const isAdd = val.value === 'true';
          const curentRtilCode = Number(val.mark);
          if (isAdd) {
            this.State.voiceCommandList.push(curentRtilCode);
          } else {
            this.State.voiceCommandList = this.State.voiceCommandList.filter(rtilCode => {
              return rtilCode != curentRtilCode;
            });
          }
        }
      });
    });
    Bus.$on('endParty', v => {
      this.loadChatBox = false;
      this.allowedList = {};
      this.rtc && this.rtc.leave();
      this.shareClient && this.cancelStopShare();
      this.shareClient && this.shareClient.leave();
      this.clearStatus();
      this.$router.push({
        name: 'remove',
        query: {
          type: 'end'
        }
      });
    });
    Bus.$on('setOutput', v => {
      this.State.outputCode = v.rtilCode;
      this.outputRtilCode = v.rtilCode;
      this.leftRightShareRtilCode = v.rtilCode;
      this.State.commonHostLeftRight = true;
      this.leftRightRtilCode = v.rtilCode;
      // 处理与会者上大屏时sharescreen消失
      this.showShareScreen = true;
      this.dealSubscribeVideo({
        id: v.rtilCode
      });
      this.handleRtilCodeList();
      setTimeout(() => {
        this.MeInfo = {
          ...this.MeInfo,
          ...v
        };
      }, 100);
    });
    Bus.$on('cancelOutput', v => {
      const _this = this;
      // 处理与会者上大屏时sharescreen消失
      this.showShareScreen = false;
      // 如果大屏在右边 list 列表里时，取消上大屏不取消左右布局
      if (!this.leftRightShareRtilCode || this.leftRightShareRtilCode == v.rtilCode) {
        this.leftRightShareRtilCode = '';
        this.State.commonHostLeftRight = false;
        this.leftRightRtilCode = '';
      }
      if (this.State.audioType == 1 && !this.shareList[v.rtilCode]) {
        var _this$rtc2;
        this.channels[v.rtilCode].hasUnsubscribe = true;
        if (!this.State.localShareInfo[v.rtilCode]) (_this$rtc2 = this.rtc) === null || _this$rtc2 === void 0 ? void 0 : _this$rtc2.unsubscribe(v.rtilCode, 'video', 'unExecuteCallback');
      }
      this.outputRtilCode = '';
      // 当取消share的大屏是，最好重新查询一下列表的list
      this.$nextTick(() => {
        if (v.rtilCode == this.userInfo.rtilCode) {
          var _this$rtc3, _this$rtc3$_localVide;
          (_this$rtc3 = _this.rtc) === null || _this$rtc3 === void 0 ? void 0 : (_this$rtc3$_localVide = _this$rtc3._localVideoTrack) === null || _this$rtc3$_localVide === void 0 ? void 0 : _this$rtc3$_localVide.play('local_stream');
        }
        this.handleRtilCodeList();
      });
    });
    Bus.$on('changeResolution', v => {
      if (!this.partyCode) return;
      // 上报分辨率
      const params = {
        partyCode: this.partyCode,
        module: 'videoQuality',
        msg: {
          videoQuality: v
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=79281', params);
    });
    // 获取rtil对应的R的状态
    Bus.$off('pageSerBusCallback');
    Bus.$on('pageSerBusCallback', v => {
      if (v.partyCode != this.partyCode) return;
      this.pageSerBusCallback(v);
    });
    Bus.$on('rtilLiveStatus', v => {
      this.rtilStatusObj = v;
      // 处理R作为与会者加入会议 将其作为rtil状态
      Object.keys(this.deviceType).forEach(itemVal => {
        Object.keys(v).forEach(item => {
          if (item == itemVal) {
            this.rtilStatusObj[item] = {
              ...v[item],
              channel: this.partyCode,
              type: this.deviceType[item]
            };
          }
        });
      });
    });
    Bus.$on('refreshSourceStatus', v => {
      v.forEach(item => {
        if (item.livePeerName && item.status == 2) {
          if (item.type == 'T') {
            this.livePeerMap[this.devicePeerIdInfo[item.peerId]] = {
              ...item,
              channel: this.partyCode // 添加额外的channel字段
            };
          }
        }

        if (!item.livePeerName && item.status != 2) {
          this.livePeerMap && Object.keys(this.livePeerMap).forEach(key => {
            if (item.peerId == this.livePeerMap[key].peerId) {
              delete this.livePeerMap[key];
            }
          });
        }
        this.deviceStatusObj = this.livePeerMap;
      });
    });
    Bus.$on('responseControlBehavior', v => {
      const {
        key,
        rtilCode,
        responseCode,
        senderRtilCode
      } = v;
      // 为了兼容anywhere，目前anywhere不会传递host的rtilCode，所以直接提示，之后添加就给rtiCode == -1添加去掉
      if (rtilCode == this.userInfo.rtilCode || rtilCode == -1) {
        if (key === 'camera') {
          if (responseCode == 2) {
            this.$set(this.State.cameraStatus, senderRtilCode, false);
            this.$message.warning(this.$t('kioskHost.requestDeny'));
          }
          if (responseCode == 3) {
            this.$message.warning(this.$t('common.operationCameraFailed'));
          }
        }
        if (key == 'mic') {
          if (responseCode == 3) {
            this.$message.warning(this.$t('common.operationMicroFailed'));
          }
        }
      }
    });
    Bus.$on('videoQuality', v => {
      this.getRtcStats(v);
    });
    Bus.$on('downlinkNetworkQuality', val => {
      // 判断当前所选择的 audio-only 模式，如果是 all time 的话则不需要走这段逻辑
      if (this.State.audioType || this.State.audioType == 2) return;
      // 当连续8s处于若网时，则改为只订阅音频流,连续6s状态良好则恢复订阅视频流
      if (val < 4) {
        if (this.lowNetworkTime > 0) {
          this.lowNetworkTime--;
        } else {
          this.lowNetworkTime = 0;
        }
        if (this.lowNetwork && this.lowNetworkTime === 0) {
          this.lowNetwork = false;
          Object.keys(this.channels).forEach(rtilCode => {
            if (rtilCode != this.userInfo.rtilCode && this.channels[rtilCode].hasUnsubscribe) {
              // 自己的屏幕分享不需要订阅
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', '', true);
              this.channels[rtilCode].hasUnsubscribe = false;
            }
          });
          this.State.inAudioOnlyStatus = false;
          this.initAudioOnlyPopup = true;
        }
      } else {
        if (this.lowNetworkTime < 3) {
          this.lowNetworkTime++;
        } else if (this.lowNetworkTime === 3) {
          this.lowNetwork = true;
        }
        if (this.lowNetwork) {
          Object.keys(this.channels).forEach(rtilCode => {
            if (rtilCode != this.userInfo.rtilCode && !this.channels[rtilCode].hasUnsubscribe) {
              if (!((this.outputRtilCode == rtilCode || this.leftRightRtilCode == rtilCode) && this.State.checkMainWindow) && !(this.shareList[rtilCode] && this.State.checkShareScreen)) {
                this.dealLocalShareScreen(rtilCode, 'needControlPlay', '', false);
                this.channels[rtilCode].hasUnsubscribe = true;
              }
            }
          });
          this.State.inAudioOnlyStatus = true;
          if (this.initAudioOnlyPopup) {
            this.initAudioOnlyPopup = false;
            this.$message.success(this.$t('netWorkStatus.poorNetworkPopup'));
          }
        }
      }
    });
    Bus.$on('setLoginScreenButton', async val => {
      const {
        buttonType,
        operationType
      } = val.buttonStatus;
      if (buttonType === 6) {
        var _this$rtc4;
        if (operationType === 1 && (_this$rtc4 = this.rtc) !== null && _this$rtc4 !== void 0 && _this$rtc4._localAudioTrack) {
          this.startHearSelf = true;
          this.iconList.forEach(item => {
            if (item === 'speaker') {
              this.iconList.push('hearMyself');
            }
          });
          if (this.hearSelf && !this.State.isMute && this.State.micStatus[this.userInfo.rtilCode] && this.rtc) {
            this.rtc.play(this.rtc._localAudioTrack, '', {
              type: 'audio'
            });
          }
        } else if (operationType === 1) {
          this.startHearSelf = true;
          this.iconList.forEach(item => {
            if (item === 'speaker') {
              this.iconList.push('hearMyself');
            }
          });
        } else {
          this.startHearSelf = false;
          this.iconList.forEach((item, index) => {
            if (item === 'hearMyself') {
              this.iconList.splice(index, 1);
            }
          });
          this.rtc && this.rtc.stop(this.rtc._localAudioTrack);
          this.saveHearSelfBehavior(false);
        }
      } else if (buttonType === 7) {
        if (operationType) {
          this.hadOpenWebCloud = true;
          if (this.rtc) {
            try {
              await this.rtc.leave();
            } catch (e) {
              console.log('leave rtc failed');
            }
          }
          this.userInfo.status.cloudProxy = 1;
          this.joinAgoraClient(this.userInfo, this.userInfo.behavior, this.joinParam, 'notInitStatus');
        } else {
          this.hadOpenWebCloud = false;
          this.userInfo.status.cloudProxy = 0;
          if (this.rtc) {
            try {
              await this.rtc.leave('closeCLoudProxy');
            } catch (e) {
              console.log('leave closeCloudProxy failed');
            }
          }
          this.joinAgoraClient(this.userInfo, this.userInfo.behavior, this.joinParam, 'notInitStatus');
        }
      } else if (buttonType === 9) {
        this.controlAudioMatrix(operationType);
        if (operationType === 0) {
          this.State.audioMatrixEnable = false;
          this.userInfo.status.audioMatrix = 0;
        } else {
          this.State.audioMatrixEnable = true;
          this.userInfo.status.audioMatrix = 1;
        }
        Object.keys(this.State.startPrivateInfo).forEach(hostRtilCode => {
          this.State.startPrivateInfo[hostRtilCode].forEach(talkToRtilCode => {
            this.privateConversationFn({
              type: 'cancelPrivateConversation',
              hostRtilCode,
              rtilCode: talkToRtilCode,
              channel: this.userInfo.joinCode
            });
          });
        });
      } else if (buttonType === 4) {
        // co-host页面按钮状态同步
        if (operationType === 0) {
          this.userInfo.status.lockName = 0;
        } else {
          this.userInfo.status.lockName = 1;
        }
      } else if (buttonType === 1) {
        // co-host页面按钮状态同步
        if (operationType === 0) {
          this.userInfo.status.hasCopy = 0;
        } else {
          this.userInfo.status.hasCopy = 1;
        }
      } else if (buttonType === 0) {
        // co-host页面按钮状态同步
        if (operationType === 0) {
          this.userInfo.status.loginButton = 0;
        } else {
          this.userInfo.status.loginButton = 1;
        }
      } else if (buttonType === 5) {
        // co-host页面按钮状态同步
        if (operationType === 0) {
          this.userInfo.status.hotJar = 0;
        } else {
          this.userInfo.status.hotJar = 1;
        }
      } else if (buttonType === 8) {
        // co-host页面按钮状态同步
        const _this = this;
        if (operationType === 0) {
          _this.userInfo.status.Chatlio = 0;
        } else {
          _this.userInfo.status.Chatlio = 1;
        }
      } else if (buttonType === 12) {
        // 如果关闭私聊功能需要把除了 host 之外的私聊状态都清除掉
        if (!operationType) {
          Object.keys(this.State.startPrivateInfo).forEach(rtilCode => {
            if (this.channels[rtilCode] && this.channels[rtilCode].audioTrack) {
              var _this$rtc5;
              (_this$rtc5 = this.rtc) === null || _this$rtc5 === void 0 ? void 0 : _this$rtc5.play(this.channels[rtilCode].audioTrack, '', {
                type: 'audio'
              });
            }
            this.$delete(this.State.startPrivateInfo, rtilCode);
          });
        }
      } else if (buttonType === 14) {
        this.State.aiBotEnable = operationType;
      } else if (buttonType === 15) {
        if (operationType === 1) {
          this.getAllGroup();
        } else {
          this.State.groupList = [];
          this.State.pressShortCut = 0;
          this.State.shortCutArray = {};
          this.State.currentPushTalkInfo = {};
        }
      } else if (buttonType === 16 || buttonType === 20) {
        if (buttonType === 20) {
          if (operationType == 1) {
            this.muteAmAudio = true;
          } else {
            this.muteAmAudio = false;
          }
        }
        if (operationType !== 1) {
          Object.keys(this.State.currentPushTalkInfo).forEach(key => {
            if (this.State.currentPushTalkInfo[key].partyCode != this.userInfo.joinCode) {
              this.State.currentPushTalkInfo[key].talk = false;
            }
          });
        }
      } else if (buttonType === 17) {
        if (operationType === 0) {
          this.audioLevel = true;
          this.$message.success(this.$t('remainWords.hostChangeAudioLevel'));
        } else {
          this.audioLevel = false;
          this.$message.success(this.$t('remainWords.hostChangeAudioBar'));
        }
      }
    });
    Bus.$on('subscribeAudioControl', val => {
      if (val) {
        if (val == 2) {
          Object.keys(this.channels).forEach(rtilCode => {
            if (rtilCode != this.userInfo.rtilCode && this.channels[rtilCode].hasUnsubscribe) {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[rtilCode].hasUnsubscribe = false;
            }
          });
          return; // 2 是关闭 audio-only 状态不用订阅
        }

        Object.keys(this.channels).forEach(rtilCode => {
          if (rtilCode != this.userInfo.rtilCode && !this.channels[rtilCode].hasUnsubscribe) {
            // 需要判断当前的 mainWindow 和 shareScreen 是否处于选中状态，选中需要订阅
            if (this.outputRtilCode == rtilCode || this.leftRightRtilCode == rtilCode) {
              if (!this.State.checkMainWindow && !this.shareList[rtilCode]) {
                this.dealLocalShareScreen(rtilCode, 'needControlPlay', '', false);
                this.$set(this.channels[rtilCode], 'hasUnsubscribe', true);
              }
            } else if (this.shareList[rtilCode]) {
              if (!this.State.checkShareScreen) {
                this.dealLocalShareScreen(rtilCode, 'needControlPlay', '', false);
                this.$set(this.channels[rtilCode], 'hasUnsubscribe', true);
              }
            } else {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', '', false);
              this.$set(this.channels[rtilCode], 'hasUnsubscribe', true);
            }
          }
        });
      } else {
        Object.keys(this.channels).forEach(rtilCode => {
          if (rtilCode != this.userInfo.rtilCode && this.channels[rtilCode].hasUnsubscribe) {
            // 需要判断当前的 mainWindow 和 shareScreen 是否处于选中状态，选中需要订阅
            if (this.outputRtilCode == rtilCode) {
              // 分为两种情况一种网络较好(可以不取参考checkbox)，另外一种是网络不好需要参考checkbox
              if (!this.State.inAudioOnlyStatus) {
                this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
                this.channels[rtilCode].hasUnsubscribe = false;
              } else {
                if (this.State.checkMainWindow) {
                  this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
                  this.channels[rtilCode].hasUnsubscribe = false;
                }
              }
            } else if (this.shareList[rtilCode]) {
              if (!this.State.inAudioOnlyStatus) {
                this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
                this.channels[rtilCode].hasUnsubscribe = false;
              } else {
                if (this.State.checkShareScreen) {
                  this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
                  this.channels[rtilCode].hasUnsubscribe = false;
                }
              }
            } else {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[rtilCode].hasUnsubscribe = false;
            }
          }
        });
      }
    });
    Bus.$on('dealMainAudioOnly', val => {
      const pinnCode = this.outputRtilCode || this.leftRightRtilCode;
      if (pinnCode) {
        // 先判断当前处于哪种模式下
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            this.dealLocalShareScreen(pinnCode, 'needControlPlay', 'unExecuteCallback', true);
            this.channels[pinnCode].hasUnsubscribe = false;
          } else {
            if (val) {
              this.dealLocalShareScreen(pinnCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[pinnCode].hasUnsubscribe = false;
            } else {
              if (!this.shareList[pinnCode] || this.shareList[pinnCode] && !this.State.checkShareScreen) {
                this.dealLocalShareScreen(pinnCode, 'needControlPlay', 'unExecuteCallback', true);
                this.channels[pinnCode].hasUnsubscribe = true;
              }
            }
          }
        } else {
          // 如果是 auto audio-only 需要先判断当前是否处于 audio-only 状态中
          if (!this.State.inAudioOnlyStatus) {
            this.dealLocalShareScreen(pinnCode, 'needControlPlay', 'unExecuteCallback', true);
            this.channels[pinnCode].hasUnsubscribe = false;
          } else {
            if (val) {
              this.dealLocalShareScreen(pinnCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[pinnCode].hasUnsubscribe = false;
            } else {
              this.dealLocalShareScreen(pinnCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[pinnCode].hasUnsubscribe = true;
            }
          }
        }
      }
    });
    Bus.$on('dealShareAudioOnly', val => {
      Object.keys(this.shareList).forEach(rtilCode => {
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
            this.channels[rtilCode].hasUnsubscribe = false;
          } else {
            if (val) {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[rtilCode].hasUnsubscribe = false;
            } else {
              if (rtilCode == this.outputRtilCode && !this.State.checkMainWindow) {
                this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', false);
                this.channels[rtilCode].hasUnsubscribe = true;
              } else if (rtilCode != this.outputRtilCode) {
                this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', false);
                this.channels[rtilCode].hasUnsubscribe = true;
              }
            }
          }
        } else {
          if (!this.State.inAudioOnlyStatus) {
            this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
            this.channels[rtilCode].hasUnsubscribe = false;
          } else {
            if (val) {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[rtilCode].hasUnsubscribe = false;
            } else {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', false);
              this.channels[rtilCode].hasUnsubscribe = true;
            }
          }
        }
      });
    });
    // co-host
    Bus.$on('collaborateInvite', result => {
      const {
        collaborateUserId,
        status,
        toEmail,
        PartyCode
      } = result;
      if (PartyCode) {
        // co-host页面
        if (collaborateUserId == this.State.loginInfo.id) {
          status === 0 ? this.coHostInfo.show = true : this.coHostInfo.show = false;
          if (status === 0) {
            this.coHostInfo.info = result;
          } else if (status === 2) {
            this.coHostInfo.info = {};
          }
        } else {
          // host页面
          if (status === 1) {
            this.$message.success(toEmail + this.$t('personalInfo.accepted'));
          } else if (status === 2) {
            this.$message.warning(toEmail + this.$t('personalInfo.refuseInvite'));
          }
        }
      }
    });
    Bus.$on('deleteCollaborateInvite', result => {
      const {
        deletedUserEmail,
        PartyCode
      } = result;
      if (deletedUserEmail === this.loginInfo.email && PartyCode == this.realPartyCode) {
        this.coHostInfo.show = false;
        this.$router.push({
          name: 'remove',
          query: {
            type: 'cancelInvite',
            partyCode: PartyCode
          }
        });
      }
    });
    Bus.$on('collaborateInvite', result => {
      if (!result.PartyCode) {
        const {
          collaborateUserId,
          status,
          toEmail
        } = result;
        if (collaborateUserId == this.State.loginInfo.id) {
          status === 0 ? this.collaborateInfo.show = true : this.collaborateInfo.show = false;
          if (status === 0) {
            this.collaborateInfo.info = result;
          } else if (status === 2) {
            this.collaborateInfo.info = {};
          }
        } else {
          if (status === 1) {
            this.$message.success(toEmail + this.$t('personalInfo.accepted'));
          } else if (status === 2) {
            this.$message.warning(toEmail + this.$t('personalInfo.refuseInvite'));
          }
        }
      }
    });
    Bus.$on('audioOn', result => {
      const {
        rtilCode,
        muteRtilCode
      } = result;
      // 更新所有 Audio Matrix 信息
      if (this.State.matrixInfoMuteMap[rtilCode]) {
        this.State.matrixInfoMuteMap[rtilCode] = this.State.matrixInfoMuteMap[rtilCode].filter(rtilCode => {
          return rtilCode != muteRtilCode;
        });
      }
      if (rtilCode == this.rtilCode) {
        if (this.channels[muteRtilCode]) {
          var _this$State$matrixInf, _this$State$matrixInf2;
          if (!this.State.matrixInfoUnTalkMap[muteRtilCode] || !((_this$State$matrixInf = this.State.matrixInfoUnTalkMap[muteRtilCode]) !== null && _this$State$matrixInf !== void 0 && _this$State$matrixInf.includes(rtilCode))) {
            this.myselfMuteInfo.muteRtilCodes = this.myselfMuteInfo.muteRtilCodes.filter(rtilCode => {
              return rtilCode != muteRtilCode;
            });
          }
          this.$set(this.channels[muteRtilCode], 'muteByAudioMatrix', false);
          // 根据最新逻辑还要判断对面是否和和你 talk 了
          if (!this.State.matrixInfoUnTalkMap[muteRtilCode] || !((_this$State$matrixInf2 = this.State.matrixInfoUnTalkMap[muteRtilCode]) !== null && _this$State$matrixInf2 !== void 0 && _this$State$matrixInf2.includes(rtilCode))) {
            var _this$rtc6;
            (_this$rtc6 = this.rtc) === null || _this$rtc6 === void 0 ? void 0 : _this$rtc6.subscribe(muteRtilCode, 'audio');
          }
        }
      }
    });
    Bus.$on('audioOff', result => {
      const {
        rtilCode,
        muteRtilCode
      } = result;
      const _this = this;
      if (this.State.matrixInfoMuteMap[rtilCode]) {
        this.State.matrixInfoMuteMap[rtilCode].push(muteRtilCode);
        this.$set(this.State.matrixInfoMuteMap, rtilCode, this.State.matrixInfoMuteMap[rtilCode]);
      } else {
        this.$set(this.State.matrixInfoMuteMap, rtilCode, [muteRtilCode]);
      }
      if (rtilCode == this.rtilCode) {
        if (_this.channels[muteRtilCode]) {
          var _this$myselfMuteInfo$;
          (_this$myselfMuteInfo$ = this.myselfMuteInfo.muteRtilCodes) === null || _this$myselfMuteInfo$ === void 0 ? void 0 : _this$myselfMuteInfo$.push(muteRtilCode);
          this.$set(this.channels[muteRtilCode], 'muteByAudioMatrix', true);
          this.rtc.unsubscribe(muteRtilCode, 'audio');
        }
      }
    });
    Bus.$on('talkOn', result => {
      const {
        rtilCode,
        targetRtilCode
      } = result;
      if (this.State.matrixInfoUnTalkMap[rtilCode]) {
        const array = this.State.matrixInfoUnTalkMap[rtilCode].filter(rtilCode => {
          return rtilCode != targetRtilCode;
        });
        this.$set(this.State.matrixInfoUnTalkMap, rtilCode, array);
      }
      if (targetRtilCode == this.rtilCode) {
        if (this.channels[rtilCode]) {
          var _this$State$matrixInf3;
          // 如果这个与会者没有和自己 talk 仍然保留 mute
          if (!this.State.matrixInfoMuteMap[targetRtilCode] || !((_this$State$matrixInf3 = this.State.matrixInfoMuteMap[targetRtilCode]) !== null && _this$State$matrixInf3 !== void 0 && _this$State$matrixInf3.includes(rtilCode))) {
            this.myselfMuteInfo.muteRtilCodes = this.myselfMuteInfo.muteRtilCodes.filter(rtilCodes => {
              return rtilCodes != rtilCode;
            });
          }
        }
      }
    });
    Bus.$on('talkOff', result => {
      const {
        rtilCode,
        targetRtilCode
      } = result;
      if (this.State.matrixInfoUnTalkMap[rtilCode]) {
        this.State.matrixInfoUnTalkMap[rtilCode].push(targetRtilCode);
        this.$set(this.State.matrixInfoUnTalkMap, rtilCode, this.State.matrixInfoUnTalkMap[rtilCode]);
      } else {
        this.$set(this.State.matrixInfoUnTalkMap, rtilCode, [targetRtilCode]);
      }
      if (targetRtilCode == this.rtilCode) {
        if (this.channels[rtilCode]) {
          var _this$myselfMuteInfo$2;
          (_this$myselfMuteInfo$2 = this.myselfMuteInfo.muteRtilCodes) === null || _this$myselfMuteInfo$2 === void 0 ? void 0 : _this$myselfMuteInfo$2.push(rtilCode);
        }
      }
    });
    Bus.$on('audioMatrix', async result => {
      const _this = this;
      const {
        enable
      } = result; // true: Audio Matrix turn on, false: Audio Matrix turn off(关闭时所有人都能听见彼此声音)
      if (enable) {
        await this.getMyselfMuteInfo({
          realPartyCode: this.partyCode,
          rtilCode: this.rtilCode
        });
        this.getAllAudioMatrixMute();
      } else {
        this.myselfMuteInfo = {};
        this.State.matrixInfoMuteMap = {};
        this.State.matrixInfoUnTalkMap = {};
        Object.keys(_this.channels).forEach(rtilCode => {
          if (_this.channels[rtilCode] && _this.channels[rtilCode].muteByAudioMatrix) {
            var _this$rtc7;
            (_this$rtc7 = this.rtc) === null || _this$rtc7 === void 0 ? void 0 : _this$rtc7.subscribe(rtilCode, 'audio');
          }
        });
      }
    });
    Bus.$on('notify', v => {
      const {
        key,
        rtilCode,
        deviceInfo,
        deviceId,
        type,
        agreeControl,
        val,
        control
      } = v;
      if (key === 'sendMediaInfoToHost') {
        this.$set(this.allowedList, rtilCode, control === 'true');
        this.$set(this.otherMediaInfo, rtilCode, deviceInfo);
      } else if (key === 'changeMediaInfo') {
        Object.keys(this.otherMediaInfo).forEach(listRtilCode => {
          if (listRtilCode == rtilCode) {
            if (type == 'video') {
              this.$set(this.otherMediaInfo[rtilCode], 'cameraId', deviceId);
            } else {
              this.$set(this.otherMediaInfo[rtilCode], 'microphoneId', deviceId);
            }
          }
        });
      } else if (key === 'responseControlMedia') {
        if (agreeControl) {
          this.$set(this.allowedList, rtilCode, true);
          if (!this.allowedList[rtilCode] && rtilCode == this.userInfo.rtilCode) {
            this.$message.success(this.$t('common.requestAgree'));
          }
        } else {
          // 同步更新下拉框所选择的内容
          Object.keys(this.otherMediaInfo).forEach(listRtilCode => {
            if (listRtilCode == rtilCode) {
              if (type === 'video') {
                this.$set(this.otherMediaInfo[listRtilCode], 'cameraId', deviceId);
              } else {
                this.$set(this.otherMediaInfo[listRtilCode], 'microphoneId', deviceId);
              }
            }
          });
          if (rtilCode != this.userInfo.rtilCode) {
            this.$message.error(this.$t('common.requestDeny'));
          }
        }
      } else if (key === 'operateMediaResult') {
        val == true ? this.$message.success(this.$t('common.setMicCameraSuccess')) : this.$message.warning(this.$t('common.setMicCameraFailed'));
      } else if (key == 'getMediaInfo') {
        // 获取host/cohost设备列表
        // if (this.userInfo.participantRole == 1) {
        this.sendMediaInfoToHost(this.rtilCode);
        // }
      } else if (key === 'changeParticipantMedia') {
        // 修改设备弹窗
        this.controlMediaInfo.info = v;
        if (this.State.partyJoinInfo.behavior.enableControlMedia === 'true') {
          if (this.rtilCode === v.rtilCode) {
            this.controlModify(true);
          }
        } else {
          if (v.rtilCode === this.rtilCode) {
            this.controlMediaInfo.show = true;
          }
        }
      }
    });
    Bus.$on('setVoiceCommandProduction', v => {
      const {
        productionId
      } = v;
      this.State.productionId = productionId;
    });
    Bus.$on('pushToTalk', v => {
      const {
        id
      } = v;
      this.$set(this.State.currentPushTalkInfo, id, v);
    });
    Bus.$on('showAddDeviceBox', () => {
      this.showV3List();
    });
    Bus.$on('cancelScreen', val => {
      if (val.rtilCode == this.leftRightRtilCode) {
        this.leftRightRtilCode = '';
      }
    });
  },
  mounted() {
    this.canvas = document.getElementById('mirrorLocal');
    this.ctx = document.getElementById('mirrorLocal').getContext('2d');
    window.addEventListener('resize', () => {
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        // 避免dom结构一直渲染，只执行最后一次
        this.changeLayout();
      }, 100);
    });
    if (!this.State.volumeBar) {
      this.State.volumeBar = new VolumeBar();
    }
  },
  methods: {
    dealLocalShareScreen(rtilCode, needControlPlay, unExecuteCallback, val) {
      if (!this.rtc) return;
      // 先判断是否有自己分享的视频
      if (JSON.stringify(this.State.localShareInfo) == '{}' || !this.State.localShareInfo[rtilCode]) {
        val ? this.rtc.subscribe(rtilCode, 'video', unExecuteCallback) : this.rtc.unsubscribe(rtilCode, 'video', unExecuteCallback);
      } else {
        // 如果有自己分享的视频，再去比较当前的 rtilCode 是否是分享视频的 rtilCode
        if (this.State.localShareInfo[rtilCode]) {
          if (!needControlPlay) return;
          if (rtilCode == this.outputRtilCode) {
            this.$refs.leftRight.controlLocalSharePlay(rtilCode, val);
          } else {
            this.$refs[`remoteSingleSource${rtilCode}`] && this.$refs[`remoteSingleSource${rtilCode}`][0].controlLocalSharePlay(rtilCode, val);
          }
        }
      }
    },
    detecteMicMuted() {
      const mediaStream = this.rtc._localAudioTrack._mediaStreamTrack;
      this.osLevelmicMuted = mediaStream.muted;
      mediaStream.onmute = () => {
        this.osLevelmicMuted = true;
      };
      mediaStream.onunmute = () => {
        this.osLevelmicMuted = false;
      };
    },
    openMicMuted() {
      window.open('ms-settings:sound', '_blank');
    },
    openliveAndLazyAudio(value) {
      if (value) {
        this.starting = true;
        if (this.talkbackStatus) {
          this.liveAndLazyAudioInfo.show = true;
        }
      } else {
        this.starting = false;
      }
    },
    notRemind(val) {
      this.checkRemindMe = val;
      localStorage.setItem(`aiPolicyNotShown_${handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime()}`, val);
    },
    returnEmailTips(type) {
      if (type === 'sendByEmail') {
        return this.$t('aiSpeech.sendEmailTips') + '<br/>' + this.$t('aiSpeech.sendEmailTips2');
      } else {
        return this.$t('aiSpeech.sendSlackTips');
      }
    },
    getHistoryData(info) {
      this.axios.get(`/partyline-backend/stt/transcript/noLogin/q?partyCode=${info.joinCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          const data = res.data.result;
          if (data && data.length > 0) {
            const array = [];
            data.forEach((item, index) => {
              const decodedBytes = atob(item.text);
              const utf8Decoder = new TextDecoder();
              const originalContent = utf8Decoder.decode(new Uint8Array(decodedBytes.split('').map(char => char.charCodeAt(0))));
              const obj = {
                uid: item.rtilCode,
                content: originalContent,
                time: item.endTime
              };
              if (index == data.length - 1) {
                obj.showDivider = true;
              }
              array.push(obj);
            });
            this.sttHistoryList = array;
          }
        }
      });
    },
    showSpeechSetting() {
      this.showSetting = true;
    },
    closeSpeechSetting() {
      this.showSetting = false;
    },
    async addEmail(value) {
      if (!value || value.length === 0) return;
      this.showSavingTips = true;
      const params = {
        partyCode: this.partyCode,
        addEmails: value,
        deleteEmails: []
      };
      await this.axios.post('/partyline-backend/stt/transcript/addOrDelEmail', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.saveEmailSuccess = true;
          setTimeout(() => {
            this.showSavingTips = false;
            this.saveEmailSuccess = false;
          }, 2000);
        }
      });
    },
    deleteEmail(val) {
      const params = {
        partyCode: this.partyCode,
        addEmails: [],
        deleteEmails: [val]
      };
      this.axios.post('/partyline-backend/stt/transcript/addOrDelEmail', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$t('aiSpeech.deleteEmailSuccess');
        }
      });
    },
    async sendEmail() {
      const hasNotAddEmail = this.emailList.some(item => !item.value);
      if (hasNotAddEmail) {
        const notAddEmailList = this.emailList.filter(item => item.value).map(item => item.value);
        await this.addEmail(notAddEmailList);
      }
      this.axios.post(`/partyline-backend/stt/transcript/sendEmail?partyCode=${this.partyCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          this.sendEmailInfo.show = false;
          this.$message.success('success');
        }
      });
    },
    closeAnywherePreview() {
      // 恢复的列表对象赋值给channels
      this.$set(this.channels, this.anyWhereInfo.rtilCode, this.anyWhereRtilCodeObj);
      this.$set(this.anywhereSettingShowMap, this.anyWhereInfo.rtilCode, false);
      this.anyWhereInfo.rtilCode = '';
      this.anyWhereVideoAudioInfo = null;
    },
    changeLayout() {
      // 获取整个视频画布的宽高
      const {
        row,
        column
      } = this.getLayoutRowAndColumn();
      const percent = 16 * column / (9 * row);
      const videoCanvasWidth = this.$refs.videoCanvas && this.$refs.videoCanvas.clientWidth;
      const videoCanvasHeight = this.$refs.videoCanvas && this.$refs.videoCanvas.clientHeight - 5 - 5 - 55 * row; // (40是距离头部的距离，5是距离头部按钮的距离, 52是下拉框的高度)
      // 根据屏幕的自适应获取可适应的16:9的宽度
      if (videoCanvasWidth / percent > videoCanvasHeight) {
        // 画布的高不够，需要减少画布的宽，计算出在此高度下的最大宽
        if (this.outputRtilCode) {
          if (this.rtilCodeList.length < 24) {
            this.videoCanvasWidth = `${videoCanvasHeight * percent}px`;
          } else {
            // 当人数超过 28 人时，每个固定宽度 245px
            this.videoCanvasWidth = '100%';
          }
        } else {
          if (this.rtilCodeList.length < 28) {
            this.videoCanvasWidth = `${videoCanvasHeight * percent}px`;
          } else {
            // 当人数超过 28 人时，每个固定宽度 245px
            this.videoCanvasWidth = '100%';
          }
        }
      } else {
        this.videoCanvasWidth = null;
      }
    },
    getLayoutRowAndColumn() {
      let pipNum = 0;
      // output 是自己的时候不需要加 1
      if (this.outputRtilCode == this.userInfo.rtilCode) {
        pipNum = this.rtilCodeList.length;
      } else {
        pipNum = this.rtilCodeList.length + 1; // +1为me
      }

      if (this.outputRtilCode || this.leftRightRtilCode) {
        let row = 2;
        let column = 3;
        const num = pipNum + 4;
        if (num <= 6) {
          column = 3;
        } else if (num <= 8) {
          column = 4;
        } else if (num <= 15) {
          column = 5;
        } else if (num <= 18) {
          column = 6;
        } else {
          column = 7;
        }
        row = num % column ? parseInt(num / column) + 1 : parseInt(num / column);
        this.videoCanvasColumn = column;
        return {
          row,
          column,
          pipNum
        };
      } else {
        let column = 2;
        let row = 1;
        if (pipNum == 1) {
          column = 1;
        } else if (pipNum <= 4) {
          column = 2;
        } else if (pipNum <= 6) {
          column = 3;
        } else if (pipNum <= 12) {
          column = 4;
        } else if (pipNum <= 15) {
          column = 5;
        } else if (pipNum <= 18) {
          column = 6;
        } else {
          column = 7;
        }
        row = pipNum % column ? parseInt(pipNum / column) + 1 : parseInt(pipNum / column);
        this.videoCanvasColumn = column;
        return {
          row,
          column,
          pipNum
        };
      }
    },
    sendTranslate() {
      if (!this.State.summaryInfo.contentText) return;
      changeBehaviorStatus({
        key: 'summaryLanguage',
        rtilCode: this.userInfo.rtilCode,
        realPartyCode: this.userInfo.realPartyCode,
        value: this.translateInto || ''
      });
      this.$refs.aiSpeech && this.$refs.aiSpeech.createSummary(this.translateInto);
    },
    listenerKeyDown(event, item) {
      if (event.repeat) return;
      // 如果是来自INPUT, TEXTAREA或内容可编辑的元素，直接返回，不处理
      if (['INPUT', 'TEXTAREA'].includes(event.target.tagName) || event.target.isContentEditable) {
        return;
      }
      const currentTime = Date.now();
      if (!this.State.pressShortCut) {
        if (item) {
          event.preventDefault();
          // 检查是否在0.5秒内
          if (this.lastApiCall && currentTime - this.lastApiCall < 500) {
            this.$message.warning(this.$t('common.quicklyTalkFailed'));
            return; // 超过时间间隔，直接返回
          }

          this.State.pressShortCut = item.key;
          this.sendPushTalk(item, true);
          this.lastApiCall = currentTime;
        } else {
          Object.keys(this.State.shortCutArray).forEach(key => {
            if (key == Number(event.key) && !event.ctrlKey && !event.altKey && !event.shiftKey) {
              event.preventDefault();
              // 检查是否在0.5秒内
              if (this.lastApiCall && currentTime - this.lastApiCall < 500) {
                this.$message.warning(this.$t('common.quicklyTalkFailed'));
                return; // 超过时间间隔，直接返回
              }

              this.State.pressShortCut = Number(event.key);
              this.sendPushTalk(this.State.shortCutArray[key], true);
              this.lastApiCall = currentTime; // 更新最后一次调用时间
            }
          });

          if (event.ctrlKey && event.keyCode === 76) {
            if (this.$refs.localSingleSource && this.talkbackStatus) {
              if (this.talkBackInfo[this.userInfo.rtilCode]) {
                this.$refs.localSingleSource.setTalkback();
              } else {
                var _this$rtilStatusObj$t, _this$deviceStatusObj;
                if (this.rtilStatusObj[this.userInfo.rtilCode] && (_this$rtilStatusObj$t = this.rtilStatusObj[this.userInfo.rtilCode].peerId) !== null && _this$rtilStatusObj$t !== void 0 && _this$rtilStatusObj$t.includes('fffff')) {
                  this.$message.error(this.$t('addWords.failToTalkBack'));
                  return;
                }
                // 设备T
                if (this.deviceStatusObj[this.userInfo.rtilCode] && (_this$deviceStatusObj = this.deviceStatusObj[this.userInfo.rtilCode].peerId) !== null && _this$deviceStatusObj !== void 0 && _this$deviceStatusObj.includes('fffff')) {
                  this.$message.error(this.$t('addWords.failToTalkBack'));
                  return;
                }
                this.$refs.localSingleSource.setTalkback();
              }
            }
            window.event.preventDefault();
          }
        }
      }
    },
    listenerKeyUp(event, item) {
      const currentTime = Date.now();
      if (this.State.pressShortCut) {
        if (item) {
          // 检查是否在0.5秒内
          if (this.lastApiCall && currentTime - this.lastApiCall < 500) {
            this.$message.warning(this.$t('common.quicklyTalkFailed'));
            return; // 超过时间间隔，直接返回
          }

          this.State.pressShortCut = 0;
          this.hasPushToTalk = false;
          this.State.pushTalking = false;
          this.sendPushTalk(item, false);
          this.lastApiCall = currentTime;
        } else {
          // 检查是否在0.5秒内
          if (this.lastApiCall && currentTime - this.lastApiCall < 500) {
            this.$message.warning(this.$t('common.quicklyTalkFailed'));
            return;
          }
          this.State.pressShortCut = 0;
          this.hasPushToTalk = false;
          this.State.pushTalking = false;
          Object.keys(this.State.shortCutArray).forEach(key => {
            if (key == Number(event.key) && !event.ctrlKey && !event.altKey && !event.shiftKey) {
              this.sendPushTalk(this.State.shortCutArray[key], false);
            }
          });
          this.lastApiCall = currentTime;
        }
      }
    },
    sendPushTalk(item, val) {
      if (this.hasPushToTalk) return;
      // const currentTime = Date.now()
      // if (currentTime - this.controlTalkBtnTime < this.dealyExecuteTimeL) {
      //   this.$message.warning(this.$t('common.quicklyTalkFailed'))
      //   return
      // } else {
      //   this.controlTalkBtnTime = currentTime
      // }
      const params = {
        partyCode: this.userInfo.joinCode,
        startRtilCode: this.userInfo.rtilCode,
        groupName: item.groupName,
        rtilCodeList: item.rtilCodeList,
        talk: val,
        id: item.id,
        timestamp: Date.now()
      };
      let url;
      if (this.muteAmAudio) {
        url = val ? '/partyline-backend/pushToTalk/noLogin/enableTalk' : '/partyline-backend/pushToTalk/noLogin/disableTalk';
        params._live = true;
      } else {
        url = '/partyline-backend/pushToTalk/noLogin/talk';
      }
      this.axios.post(url, params).then(async res => {
        if (res.data.errorCode === '0x0') {
          this.hasPushToTalk = val;
          this.State.pushTalking = val;
          if (!val) {
            this.State.pressShortCut = 0;
          }
          if (!this.rtc) return;
          // 需要判断当前 mic 是否 mute， 如果 mute 需要临时打开，然后再恢复到原来状态
          if (val) {
            if (!this.State.micStatus[this.userInfo.rtilCode]) {
              this.State.micStatus[this.userInfo.rtilCode] = true;
              this.needReMute = true;
              // 判断是否有 audiotrack
              if (this.rtc._localAudioTrack) {
                controlDevicePublish(this.rtc, 'publish', [this.rtc._localAudioTrack]);
              } else {
                // 初始化的时候没有本地音频轨道，需要重新获取
                controlAudio(this.rtc, this.devicesInfo, true, result => {});
              }
            }
          } else {
            if (this.needReMute) {
              this.needReMute = false;
              this.State.micStatus[this.userInfo.rtilCode] = false;
              controlDevicePublish(this.rtc, 'unpublish', [this.rtc._localAudioTrack]);
            }
          }
        }
      });
    },
    getAllGroup() {
      // State.currentPushTalkInfo 用来判断是否有声音
      // group list 用来显示数据
      let localGroupNumber = 0;
      this.State.shortCutArray = {};
      const params = {
        partyCode: this.userInfo.joinCode
      };
      this.axios.post('/partyline-backend/pushToTalk/noLogin/groupList', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          result.forEach(item => {
            item.rtilCodeList = item.rtilCodeList || [];
            item.rtilCodeList = item.rtilCodeList.filter(rtilCode => {
              return rtilCode !== this.userInfo.rtilCode && rtilCode != this.State.outputCode;
            });
            item.rtilCodeList.unshift(this.userInfo.rtilCode);
            this.$set(this.State.currentPushTalkInfo, item.id, item);
            if (item.partyCode == this.userInfo.joinCode && item.startRtilCode == this.userInfo.rtilCode) {
              localGroupNumber++;
              this.$set(this.State.shortCutArray, localGroupNumber < 9 ? localGroupNumber : 0, item);
            }
          });
          this.State.groupList = result.filter(item => {
            return item.partyCode == this.userInfo.joinCode && item.startRtilCode == this.userInfo.rtilCode;
          });
        }
      });
    },
    copySummary() {
      if (navigator.clipboard) {
        const text = this.State.summaryInfo.contentText;
        navigator.clipboard.writeText(text).then(() => {
          this.$message({
            message: this.$t('aiSpeech.copySuccess'),
            type: 'success'
          });
        }).catch(() => {
          this.$message({
            message: this.$t('aiSpeech.copyFail'),
            type: 'error'
          });
        });
      } else {
        this.$message({
          message: this.$t('aiSpeech.notSupportCopy'),
          type: 'error'
        });
      }
    },
    downloadSummary() {
      const text = this.State.summaryInfo.contentText;
      const blob = new Blob([text], {
        type: 'text/plain'
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'summary.txt'); // 指定下载文件的名称
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    createSpeechTest() {
      const _this = this;
      // 检查浏览器是否支持Web Speech API
      if (!('webkitSpeechRecognition' in window)) {
        alert('您的浏览器不支持web speech api');
      } else {
        // 创建speech recognition对象
        var recognition = new webkitSpeechRecognition();
        recognition.continuous = true; // 设置连续识别模式
        recognition.interimResults = true; // 设置返回临时结果
        recognition.lang = 'zh'; // 设置语言
        recognition.maxSpeechTime = 6000;

        // 开始识别
        recognition.start();
        console.log('webkitSpeechRecognition', 'start');
        recognition.onaudiostart = function () {
          console.log('webkitSpeechRecognition', 'Speech has been detected.');
        };
        recognition.onaudioend = function () {
          console.log('webkitSpeechRecognition', 'Speech has stoped being detected.');
        };
        recognition.onsoundstart = function () {
          console.log('webkitSpeechRecognition', 'Some sound is being received.');
        };
        recognition.onsoundend = function () {
          console.log('webkitSpeechRecognition', 'Sound has stoped being received.');
        };
        recognition.onspeechstart = function () {
          console.log('webkitSpeechRecognition', 'Speech has been detected.');
        };
        recognition.onspeechend = function () {
          console.log('webkitSpeechRecognition', 'Speech has stoped being detected.');
        };

        // 处理结果
        recognition.onresult = function (event) {
          // 遍历结果
          for (var i = event.resultIndex; i < event.results.length; ++i) {
            // 如果是临时结果
            if (event.results[i].isFinal) {
              var _event$results$i$0$tr;
              _this.final_transcript += event.results[i][0].transcript;
              if ((_event$results$i$0$tr = event.results[i][0].transcript) !== null && _event$results$i$0$tr !== void 0 && _event$results$i$0$tr.includes('执行')) {
                console.log('final_transcript: ', _this.final_transcript);
              }
            } else {
              _this.interim_transcript += event.results[i][0].transcript;
              // console.log('interim_transcript: ', _this.interim_transcript)
            }
          }

          _this.sendStopMainwindow();
        };

        // 处理无法识别的情况
        recognition.onerror = function (event) {
          console.log('Recognition error: ' + event.error);
        };

        // 处理识别结束
        recognition.onend = function () {
          console.log('Recognition ended.');
        };
      }
    },
    sendStopMainwindow() {
      if (this.final_transcript.includes('执行')) {
        const params = {
          command: this.final_transcript
        };
        this.axios.post('/partyline-backend/voiceCommand/execute', params).then(res => {
          this.final_transcript = '';
          if (res.data.errorCode === '0x0') {
            const result = res.data.result;
            const {
              name
            } = result;
            if (name === 'stopMainWindow' && this.outputRtilCode) {
              this.$refs.mainWindowSelect && this.$refs.mainWindowSelect.stopReceiverParty();
            } else if (name === 'openCamera' || name === 'cancelCamera') {
              const val = name === 'openCamera';
              controlCamera(this.rtc, this.devicesInfo, val);
              controlDeviceBehavior({
                senderRtilCode: this.userInfo.rtilCode,
                type: 'camera',
                value: val,
                partyCode: this.userInfo.realPartyCode,
                toRtilCode: this.userInfo.rtilCode,
                origin: 'commonPartyHost'
              });
            }
          } else {
            this.$message.error('Stop mainwindow failed');
          }
        });
      }
    },
    /**
     * 重构新加代码开始
     */
    getPartyInfo(partyCode, illegalPartyCode) {
      if (!partyCode) return;
      const params = {};
      if (illegalPartyCode) {
        params._illegalPartyCode = illegalPartyCode;
      }
      this.axios.get(`/partyline-backend/party/${partyCode}`, {
        params
      }).then(res => {
        if (!res) return;
        if (res.data.errorCode == '0x0') {
          const result = res.data.result;
          if (!result) return;
          const {
            code,
            layout,
            column,
            layoutName,
            title,
            id,
            createTime
          } = result;
          this.userInfo = {};
          this.allRtilList = [];
          this.rtilCodeList = [];
          this.State.partyCode = partyCode;
          this.State.groupLayout = {
            layout,
            column,
            layoutName
          };
          // 当前partyInfo
          this.State.currentPartyInfo = result;
          if (this.State.currentPartyInfo.code != this.$route.query.id) {
            // 为了处理url的id与当前所选择id不一致问题，切换cookie会出现
            this.$router.push({
              name: this.type,
              query: {
                id: this.State.currentPartyInfo.code
              }
            });
          }
          this.initJoinFn(code);
          // debugger
          // 传递第3个参数的目的是在control页面初始进来时，是否要cancel掉屏幕共享
          setTimeout(() => {
            Bus.$emit('changePartyAddress', {
              currentId: code,
              lastId: id,
              init: 'initAside',
              title,
              id,
              createTime
            });
          }, 500);
          handleLocalStorage('set', 'partyInfo', {
            code
          });
        }
      });
    },
    /**
     * 重构新加代码结束
     */
    getAllPrivate() {
      if (!this.partyCode) return;
      const params = {
        annotation: this.partyCode,
        key: 'privateChat',
        value: true
      };
      this.axios.post('/partyline-backend/userkkv/noLogin/getPartyCodeKey', params).then(async res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          result.forEach(item => {
            const mark = Number(item.mark);
            const subKey = Number(item.subKey);
            const remark = Number(item.remark);
            if (!this.State.startPrivateInfo[mark]) {
              this.$set(this.State.startPrivateInfo, mark, [subKey]);
            } else {
              var _this$State$startPriv2;
              if (!((_this$State$startPriv2 = this.State.startPrivateInfo[mark]) !== null && _this$State$startPriv2 !== void 0 && _this$State$startPriv2.includes(subKey))) this.State.startPrivateInfo[mark].push(subKey);
            }
            if (remark && remark == this.userInfo.rtilCode && !this.State.localSendPrivateArray.includes(subKey)) {
              this.State.localSendPrivateArray.push(subKey);
            }
          });
        }
      });
    },
    // 切换设备弹窗确认/拒绝的回调
    controlModify(agreeControl) {
      const params = {
        partyCode: this.State.partyCode,
        module: 'notify',
        msg: {
          key: 'responseControlMedia',
          rtilCode: this.rtilCode,
          agreeControl,
          type: this.controlMediaInfo.info.type,
          deviceId: this.controlMediaInfo.info.type === 'video' ? this.devicesInfo.cameraId : this.devicesInfo.microphoneId
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=27994', params).then(async res => {
        // agreeControl ? this.$message.success(this.$t('common.setMicCameraSuccess')) : this.$message.success(this.$t('common.denySuccess'))
        this.saveOperation(agreeControl);
      });
      if (agreeControl) {
        this.rtc.setDevice(this.controlMediaInfo.info.deviceId, this.controlMediaInfo.info.type, result => {
          if (result) {
            if (this.controlMediaInfo.info.type === 'video') {
              this.devicesInfo.cameraId = this.controlMediaInfo.info.deviceId;
            } else {
              this.devicesInfo.microphoneId = this.controlMediaInfo.info.deviceId;
            }
            this.sendResultToHost(true);
          } else {
            this.sendResultToHost(false);
          }
        });
      }
    },
    saveOperation(value) {
      if (!this.rtilCode || !this.State.partyJoinInfo.realPartyCode) return;
      const params = [{
        mark: this.rtilCode + '',
        annotation: this.State.partyJoinInfo.realPartyCode,
        key: 'enableControlMedia',
        value,
        notify: true
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0' && value) {
          this.State.partyJoinInfo.behavior.enableControlMedia = 'true';
        }
      });
    },
    sendResultToHost(val) {
      const params = {
        partyCode: this.State.partyCode,
        module: 'notify',
        msg: {
          key: 'operateMediaResult',
          rtilCode: this.rtilCode,
          origin: 'host',
          val
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=27994', params).then(async res => {});
    },
    // 拿cohost、host设备列表
    sendMediaInfoToHost(id) {
      const params = {
        partyCode: this.State.partyCode,
        module: 'notify',
        msg: {
          key: 'sendMediaInfoToHost',
          rtilCode: id,
          deviceInfo: this.devicesInfo,
          control: this.State.partyJoinInfo.behavior.enableControlMedia
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=27994', params).then(async res => {});
    },
    setCameraStatus() {
      controlCamera(this.rtc, this.devicesInfo, true);
      controlDeviceBehavior({
        senderRtilCode: this.userInfo.rtilCode,
        type: 'camera',
        value: true,
        partyCode: this.userInfo.realPartyCode,
        toRtilCode: this.userInfo.rtilCode,
        origin: 'commonPartyHost'
      });
    },
    sendToHost(type, value) {
      const params = {
        module: 'responseControlBehavior',
        partyCode: this.partyCode,
        origin: 'commonPartyParticipate',
        msg: {
          key: type,
          senderRtilCode: this.userInfo.rtilCode,
          rtilCode: this.hostControlPipRtilCode[type],
          responseCode: value
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=30228', params);
    },
    async controlAudioMatrix(operationType) {
      const _this = this;
      if (operationType) {
        await this.getMyselfMuteInfo({
          realPartyCode: this.partyCode,
          rtilCode: this.rtilCode
        });
        this.getAllAudioMatrixMute();
      } else {
        this.myselfMuteInfo = {};
        Object.keys(_this.channels).forEach(rtilCode => {
          if (_this.channels[rtilCode] && _this.channels[rtilCode].muteByAudioMatrix) {
            var _this$rtc8;
            (_this$rtc8 = this.rtc) === null || _this$rtc8 === void 0 ? void 0 : _this$rtc8.subscribe(rtilCode, 'audio');
          }
        });
      }
    },
    async getMyselfMuteInfo(info) {
      await this.axios.get(`/partyline-backend/audioMatrix/noLogin/get?partyCode=${info.realPartyCode}&rtilCode=${info.rtilCode}`).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          if (!res.data.result.muteRtilCodes) res.data.result.muteRtilCodes = [];
          this.myselfMuteInfo = res.data.result;
        }
      }).catch(error => {
        console.log(error);
      });
    },
    getAllAudioMatrixMute() {
      this.axios.get(`/partyline-backend/audioMatrix/noLogin/getAll?partyCode=${this.State.partyCode}`).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          const result = res.data.result;
          result.forEach(item => {
            var _this$State$matrixInf4;
            this.$set(this.State.matrixInfoMuteMap, item.rtilCode, item.muteRtilCodes);
            this.$set(this.State.matrixInfoUnTalkMap, item.rtilCode, item.unTalkRtilCodes);
            if (this.State.matrixInfoUnTalkMap[item.rtilCode] && (_this$State$matrixInf4 = this.State.matrixInfoUnTalkMap[item.rtilCode]) !== null && _this$State$matrixInf4 !== void 0 && _this$State$matrixInf4.includes(this.rtilCode)) {
              var _this$myselfMuteInfo$3;
              (_this$myselfMuteInfo$3 = this.myselfMuteInfo.muteRtilCodes) === null || _this$myselfMuteInfo$3 === void 0 ? void 0 : _this$myselfMuteInfo$3.push(item.rtilCode);
            }
          });
        }
      });
    },
    // co-host人数上限
    controlCohostLimit(val) {
      // 确认以与会者身份加入会议
      if (val == true) {
        this.asParticipants = true;
        this.$router.push({
          name: 'participate',
          query: {
            join_id: this.State.partyCode,
            asParticipants: this.asParticipants
          }
        });
      } else {
        this.$router.push({
          name: 'remove',
          query: {
            type: 'limitation'
          }
        });
      }
    },
    // co-host
    controlCohostInvite(val) {
      const params = {
        collaborateLogId: this.coHostInfo.info.collaborateLogId,
        optionType: val ? 1 : 2
      };
      this.axios.post(`/partyline-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (params.optionType == 1) {
            this.$message.success(this.$t('personalInfo.acceptHostSuccess'));
          } else {
            this.$message.success(this.$t('personalInfo.acceptHostCancel'));
          }
        } else if (res.data.errorCode == '82203101') {
          this.$message.warning(this.$t('common.invitedExpire'));
        }
      });
    },
    controlInvite(val) {
      const params = {
        collaborateLogId: this.collaborateInfo.info.collaborateLogId,
        optionType: val ? 1 : 2
      };
      this.axios.post(`/partyline-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          this.$message.success(this.$t('galleryHost.operationS'));
        } else if (res.data.errorCode == '82203101') {
          this.$message.warning(this.$t('common.invitedExpire'));
        }
      });
    },
    changeAllRList(list) {
      this.allRList = list;
    },
    listenerTalkBack(event) {
      if (event.ctrlKey && event.keyCode === 76) {
        if (this.$refs.localSingleSource && this.talkbackStatus) {
          this.$refs.localSingleSource.setTalkback();
        }
        window.event.preventDefault();
      }
    },
    handleRtilCodeList() {
      let codeList = JSON.parse(JSON.stringify(this.allRtilList));
      const shareList = JSON.parse(JSON.stringify(this.shareList));
      // 删除后台推送的 host RtilCode
      codeList = codeList.filter(v => v != this.userInfo.rtilCode);
      if (this.outputRtilCode) {
        // 过滤掉mainwindow
        codeList = codeList.filter(v => v != this.outputRtilCode);
      }
      const _this = this;
      // 如果有 share 需要把 share 视频分别放在各自发起者的右边
      if (_this.shareRtilCode && _this.shareRtilCode != this.outputRtilCode) {
        // 如果当前 host 在分享先把 自己分想的 rtilCode 去掉并添加到第一位去
        codeList = codeList.filter(rtilCode => {
          return rtilCode != _this.shareRtilCode;
        });
        codeList.unshift(_this.shareRtilCode);
        // 删除 host 的记录
        if (shareList[_this.shareRtilCode]) {
          this.$delete(shareList, _this.shareRtilCode);
        }
      }
      if (!this.showShareScreen) {
        // 先去掉所有 share 的 RtilCode
        codeList = codeList.filter(rtilCode => {
          return !shareList[rtilCode];
        });
        // 根据最新需求屏幕分享要在与会者视频右边
        for (let i = 0; i < codeList.length; i++) {
          if (_this.rtilCodeByShare[codeList[i]] && _this.rtilCodeByShare[codeList[i]] != this.outputRtilCode) {
            codeList.splice(i + 1, 0, _this.rtilCodeByShare[codeList[i]]);
          }
        }
      }
      // 如果放大的是普通的share，并且存在output，则需要把output放在rtilCodeList中
      if (this.leftRightShareRtilCode && this.outputRtilCode && this.outputRtilCode != this.leftRightShareRtilCode) {
        if (!codeList.includes(this.outputRtilCode)) {
          codeList.push(this.outputRtilCode);
        }
      }

      // 如果放大的是普通的 share，需要在 rtilCodeList 中过滤掉
      if (this.leftRightShareRtilCode) {
        codeList = codeList.filter(v => v != this.leftRightShareRtilCode);
      }
      if (this.sttRtilCode) {
        if (codeList.includes(this.sttRtilCode)) {
          this.State.showAISpeech = true;
        }
        this.rtilCodeList = codeList.filter(rtilCode => {
          return rtilCode != this.sttRtilCode;
        });
        this.allPartyMembers = this.allPartyMembers.filter(rtilCode => {
          return rtilCode != this.sttRtilCode;
        });
        // for (var i = 0; i < 26; i++) {
        //   this.rtilCodeList.push(undefined)
        // }
      } else {
        this.rtilCodeList = codeList;
      }
    },
    // 需要清除已经离开的与会者的私聊(host 发起与会者接收的这种，与会者发起的)
    cancelPrivate(result) {
      if (!this.lastPrivatePositionInfo.length) {
        this.lastPrivatePositionInfo = result.participant;
      } else {
        const currentPositionInfo = result.participant;
        const leavePositionArray = this.lastPrivatePositionInfo.filter(rtilCode => {
          return !currentPositionInfo.includes(rtilCode);
        });
        this.lastPrivatePositionInfo = result.participant;
        leavePositionArray.forEach(rtilCode => {
          var _this$State$startPriv3;
          // 取消 host 发起的私聊
          if (this.State.startPrivateInfo[this.userInfo.rtilCode] && (_this$State$startPriv3 = this.State.startPrivateInfo[this.userInfo.rtilCode]) !== null && _this$State$startPriv3 !== void 0 && _this$State$startPriv3.includes(rtilCode)) {
            this.privateConversationFn({
              type: 'cancelPrivateConversation',
              rtilCode,
              channel: this.userInfo.joinCode
            });
          }
          // 如果离开的人有发起私聊请清除私聊
          if (this.State.startPrivateInfo[rtilCode]) {
            this.State.startPrivateInfo[rtilCode].forEach(talkToRtilCode => {
              this.privateConversationFn({
                type: 'cancelPrivateConversation',
                hostRtilCode: rtilCode,
                rtilCode: talkToRtilCode,
                channel: this.userInfo.joinCode
              }, 'sendRemark');
            });
          }
        });
      }
    },
    getRList() {
      const params = {
        pageNum: 1,
        pageSize: 400,
        living: true,
        offline: false,
        online: true,
        queryCollaborate: true
      };
      this.axios.post('/partyline-backend/receiver/v3/page', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.allRList = result;
          if (this.allRList.pps && this.allRList.pps[0]) {
            this.State.ppRlist = this.allRList.pps[0].pageInfo.list;
          }
        }
      });
    },
    async dealFootEvent(info) {
      const {
        type,
        val,
        shareType
      } = info;
      switch (type) {
        case 'muteVideo':
          // 当切换到不可用设备时，先 disable 在 enable， Agora 会使用上一次的 videotrack 导致画面和所选择的选项不一致
          // 所以需要我们假装更改状态但不去执行 enable
          if (!this.rtcLoaded) return;
          if (val && this.State.anAvailbleDeviceId) {
            this.State.showInitCameraTips = true;
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, true);
          } else {
            await controlCamera(this.rtc, this.devicesInfo, val);
          }
          controlDeviceBehavior({
            senderRtilCode: this.userInfo.rtilCode,
            type: 'camera',
            value: val,
            partyCode: this.userInfo.realPartyCode,
            toRtilCode: this.userInfo.rtilCode,
            origin: 'commonPartyHost',
            notChangeStatus: true
          });
          break;
        case 'muteAudio':
          if (!this.rtcLoaded) return;
          if (this.osLevelmicMuted && !val) {
            this.showMicMutedInfo.show = true;
            return;
          }
          let operationResult = 'success';
          let time = 0;
          if (this.rtc._localAudioTrack) {
            const type = val ? 'publish' : 'unpublish';
            time = new Date().getTime();
            console.log('time', time);
            operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
          } else {
            // 初始化的时候没有本地音频轨道，需要重新获取
            controlAudio(this.rtc, this.devicesInfo, val, result => {
              if (result == 'failed') operationResult = 'failed';
            });
          }
          if (operationResult === 'success') {
            controlDeviceBehavior({
              senderRtilCode: this.userInfo.rtilCode,
              type: 'mic',
              value: val,
              partyCode: this.userInfo.realPartyCode,
              toRtilCode: this.userInfo.rtilCode,
              origin: 'commonPartyHost',
              notChangeStatus: true
            });
            console.log('time', new Date().getTime() - time);
            // 恢复听自己声音功能
            if (val && this.hearSelf && this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
              this.rtc && this.rtc.play(this.rtc._localAudioTrack, '', {
                type: 'audio'
              });
            }
          }
          break;
        case 'changeDevice':
          this.switchDevice(val);
          break;
        case 'changeMute':
          this.changeMute(val);
          break;
        case 'shareScreen':
          this.shareScreen(shareType);
          break;
        case 'showChat':
          this.showChatMessage = val;
          if (val) {
            var _this$$refs$footDiv2;
            this.showUnread = false;
            this.showAISpeech = false;
            this.loadChatBox = true;
            (_this$$refs$footDiv2 = this.$refs.footDiv) === null || _this$$refs$footDiv2 === void 0 ? void 0 : _this$$refs$footDiv2.changeVoiceValue(false);
          }
          this.$nextTick(() => {
            this.changeLayout();
          });
          break;
        case 'hearSelfFeature':
          if (val) {
            this.hearSelf = true;
            if (this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
              this.rtc && this.rtc.play(this.rtc._localAudioTrack, '', {
                type: 'audio'
              });
            }
          } else {
            this.hearSelf = false;
            if (this.rtc && this.rtc._localAudioTrack) {
              this.rtc._localAudioTrack.stop(this.rtc._localAudioTrack);
            }
          }
          this.saveHearSelfBehavior(val);
          break;
        case 'joinParty':
          if (this.canvasVideoTimer) clearInterval(this.canvasVideoTimer);
          this.canvasVideoTimer = null;
          this.useMirrorVideo('closeMirror');
          break;
        case 'openMirror':
          this.useMirrorVideo('openMirror');
          break;
        case 'changeRecord':
          this.recordLocalStream(val);
          break;
        case 'showAISpeechPop':
          this.aiPolicyInfo.show = true;
          break;
        case 'showVoice':
          this.showAISpeech = val;
          if (val) {
            this.showChatMessage = false;
            this.$refs.footDiv.changeChatValue(false);
            Bus.$emit('hideChatMove');
          }
          this.$nextTick(() => {
            this.changeLayout();
          });
          break;
      }
    },
    recordLocalStream(val) {
      if (val) {
        var _this$rtc9, _this$rtc10;
        const stream = new MediaStream();
        if ((_this$rtc9 = this.rtc) !== null && _this$rtc9 !== void 0 && _this$rtc9._localAudioTrack) stream.addTrack(this.rtc._localAudioTrack._mediaStreamTrack);
        if ((_this$rtc10 = this.rtc) !== null && _this$rtc10 !== void 0 && _this$rtc10._localVideoTrack) stream.addTrack(this.rtc._localVideoTrack._mediaStreamTrack);
        this.recordVideo = new MediaRecorder(stream);
        this.recordVideo.addEventListener('dataavailable', event => {
          this.chunks.push(event.data);
        });
        this.recordVideo.addEventListener('stop', () => {
          this.blob = new Blob(this.chunks, {
            type: 'video/mp4'
          });
        });
        this.recordVideo.start();
      } else {
        this.recordVideo.stop();
        setTimeout(() => {
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(this.blob);
          downloadLink.download = 'my-video.mp4';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          this.chunks = [];
        }, 500);
      }
    },
    useMirrorVideo(type) {
      // 首先把 local 视频流赋值到 canvas 上
      const _localVideo = $('#local_stream video')[0];
      this.drawImage(_localVideo, type);
    },
    async drawImage(_localVideo, type) {
      const _this = this;
      if (type === 'closeMirror') {
        try {
          await _this.rtc._client.unpublish([_this.rtc._customVideoTrack]);
        } catch (e) {
          console.log('unpublish failed');
        }
        if (_this.rtc && _this.rtc._localVideoTrack && _this.rtc._client) {
          var _this$rtc$_client;
          (_this$rtc$_client = _this.rtc._client) === null || _this$rtc$_client === void 0 ? void 0 : _this$rtc$_client.publish(_this.rtc._localVideoTrack);
        }
      } else {
        this.canvasVideoTimer = setInterval(() => {
          this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
          if (this.initMirror) {
            this.ctx.translate(480, 0);
            this.ctx.scale(-1, 1);
            this.initMirror = false;
          }
          this.ctx.drawImage(_localVideo, 0, 0, this.canvas.width, this.canvas.height);
        }, 0);
        setTimeout(() => {
          this.pushLocalVideo();
        }, 0);
      }
    },
    async pushLocalVideo() {
      var _this$rtc11, _this$rtc11$_client;
      if (!rtc) return;
      const _this = this;
      const stream = this.canvas.captureStream(30);
      const [videoTrack] = stream.getVideoTracks();
      const pushTrack = _this.rtc._AgoraRTC.createCustomVideoTrack({
        mediaStreamTrack: videoTrack,
        bitrateMin: this.userInfo.videoQualities[0].bitrateRange[0],
        bitrateMax: this.userInfo.videoQualities[0].bitrateRange[1],
        optimizationMode: 'detail'
      });
      this.rtc._customVideoTrack = pushTrack;
      try {
        if (_this.rtc && _this.rtc._localVideoTrack) {
          await this.rtc._client.unpublish([_this.rtc._localVideoTrack]);
        }
      } catch (e) {
        console.log('pushLocalVideo unpublish failed');
      }
      (_this$rtc11 = _this.rtc) === null || _this$rtc11 === void 0 ? void 0 : (_this$rtc11$_client = _this$rtc11._client) === null || _this$rtc11$_client === void 0 ? void 0 : _this$rtc11$_client.publish(pushTrack);
    },
    getOnlineMember() {
      this.axios.get('/partyline-backend/commonParty/noLogin/getViewRtilCodes', {
        params: {
          partyCode: this.partyCode
        }
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          var _res$data$result$view;
          const list = (_res$data$result$view = res.data.result.viewPosition) === null || _res$data$result$view === void 0 ? void 0 : _res$data$result$view.total;
          this.allRtilList = list.map(v => {
            if (!this.channels[v]) {
              this.$set(this.channels, v, {
                id: v,
                channel: this.partyCode
              });
            }
            this.getNickName(v);
            return v;
          });
          this.handleRtilCodeList();
        }
      }).catch(e => {
        console.log(e);
      });
    },
    editTagName(obj) {
      this.setTagName.show = true;
      this.setTagName.originRtilCode = this.userInfo.rtilCode;
      this.setTagName.targetRtilCode = obj.id;
      this.setTagName.partyCode = this.currentPartyInfo.code || this.State.partyCode;
      this.setTagName.tagName = this.tagNameInfo[obj.id];
    },
    saveTagName(obj) {
      this.$set(this.tagNameInfo, obj.rtilCode, obj.tagName);
    },
    closeEvent() {
      this.State.guideObjShow = false;
    },
    chatCallback({
      type,
      rtilCode,
      data
    }) {
      if (type == 'nickName') {
        this.getNickName(rtilCode);
      }
      if (type == 'unreadInfo') {
        let showUnread = false;
        Bus.$emit('chatUnread', false);
        Object.keys(data).forEach(keys => {
          if (data[keys].unRead) {
            showUnread = true;
            Bus.$emit('chatUnread', showUnread);
            this.showUnread = showUnread;
          }
        });
      }
    },
    pageSerBusCallback({
      socket,
      partyCode
    }) {
      this.wsPageSTimer = setInterval(() => {
        const rtilCodes = Object.keys(this.allAccountIdByRtilCode);
        if (this.$route.name != 'party') clearInterval(this.wsPageSTimer);

        // 发送liveRtilCodes
        const params = {
          data: JSON.stringify({
            data: JSON.stringify({
              rtilCodes: rtilCodes,
              businessId: partyCode
            }),
            module: 'rtilLiveStatus',
            type: 'rtilLiveStatus'
          }),
          serverName: 'partyline'
        };
        if (socket.client.readyState === 1 && this.$route.name == 'party') {
          socket.send(params);
        }
      }, 1000);
    },
    getBehaviorsByMemberId() {
      if (!this.partyCode.trim()) return;
      const params = {
        memberId: handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime(),
        annotation: this.partyCode.trim(),
        keys: ['nickName']
      };
      handleLocalStorage('set', 'memberId', params.memberId);
      this.axios.post('/partyline-backend/behavior/noLogin/getListByMemberId', params).then(res => {
        if (!res) return;
        const result = res.data.result;
        if (res.data.errorCode == '0x0') {
          const {
            rtilCode,
            behaviors
          } = result;
          if (rtilCode) {
            if (behaviors[rtilCode].nickName) {
              this.behaviorInfo[rtilCode] = behaviors[rtilCode].nickName;
              this.$set(this.State.globalNameInfo, rtilCode, behaviors[rtilCode].nickName);
              this.joinPartyLine(); // 有rtilCode代表设置过nickName
            } else {
              this.$router.push({
                name: 'preview',
                query: {
                  id: this.partyCode
                }
              });
            }
          } else {
            // 直接通过join接口去添加nickName（新用户）
            this.$router.push({
              name: 'preview',
              query: {
                id: this.partyCode
              }
            });
          }
        }
      }).catch(e => {
        console.log('getListByMemberId failed');
      });
    },
    async initJoinFn(partyCode) {
      // 清除上一个party的share
      this.shareClient && this.shareClient.leave();
      this.shareList = {};
      this.rtilCodeByShare = {};
      if (!partyCode || (partyCode + '').length != 12) return;

      // 重置一些默认状态
      this.setNameInfo.show = false;
      if (this.rtc) this.rtc.leave();
      this.rtc = new AgoraClient(this.callBack);
      // 获取nickName/rtilCode
      await this.$store.dispatch('checkEnv', {
        partyCode
      });
      if (!this.State.checkEnv.owner && !this.State.checkEnv.coHost && this.State.participateChannelMode[this.State.checkEnv.channelModel]) {
        // 不是登录人的party，已与会者身份进入
        this.$router.push({
          name: 'preview',
          query: {
            id: partyCode
          }
        });
        return;
      }
      // 需要先获取设备列表，并判断之前选择过的设备列表是否还存在，不存在则选择默认的
      this.devicesInfo = await this.rtc.getDevice();
      this.getBehaviorsByMemberId();
      if (!handleLocalStorage('get', 'speakerId')) {
        handleLocalStorage('set', 'speakerId', this.devicesInfo.speakerId);
      }
    },
    changeR({
      rtilCode,
      rid
    }) {
      this.$set(this.rtilCodeLiveR, rtilCode, rid);
    },
    async userJoin(payload) {
      this.$set(this.fullScreenInfo, payload.id, false);
      this.State.haveUnReadMessage = true;
      // 初始化live的对象,目的是拿到所有rtilCode的key值，在updataStatus()进行循环判断
      if (!this.rtilCodeLiveR[payload.id]) {
        this.rtilCodeLiveR[payload.id] = '';
      }
      if (!this.channels[payload.id]) {
        this.$set(this.channels, payload.id, {
          id: payload.id
        });
      }
      // 设置默认为device的status
      this.$set(this.State.cameraStatus, payload.id, false);
      this.$set(this.State.micStatus, payload.id, false);
      this.getVideoType(payload);
      // debugger
      this.sendToGetMediaInfo(payload.id);
    },
    // 用来获取对方的媒体设备(join的时候获取)
    sendToGetMediaInfo(id) {
      const params = {
        partyCode: this.State.partyCode,
        module: 'notify',
        msg: {
          key: 'getMediaInfo',
          rtilCode: id,
          origin: 'host'
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=27994', params).then(async res => {});
    },
    subscribeTrack(payload) {
      try {
        var _this$myselfMuteInfo$4;
        const {
          id,
          videoTrack,
          audioTrack
        } = payload;
        // 上报状态
        // this.reportUserChange(payload, 'addView')
        // 列表流的显示
        // 如果是自己的屏幕分享则不去订阅
        if (this.State.localShareInfo[id]) return;
        const obj = Object.assign({}, this.channels[payload.id]);
        obj.id = payload.id;
        obj.videoTrack = videoTrack;
        obj.audioTrack = audioTrack;
        if (this.anyWhereInfo.show && id == this.anyWhereInfo.rtilCode) {
          this.anyWhereVideoAudioInfo = obj;
        }
        if (JSON.stringify(this.myselfMuteInfo) != '{}' && this.State.audioMatrixEnable && (_this$myselfMuteInfo$4 = this.myselfMuteInfo.muteRtilCodes) !== null && _this$myselfMuteInfo$4 !== void 0 && _this$myselfMuteInfo$4.includes(id)) {
          var _this$rtc12;
          // 首先判断是否处于私聊状态,在私聊的状态可以不受 host audio matrix 的控制
          obj.muteByAudioMatrix = true;
          (_this$rtc12 = this.rtc) === null || _this$rtc12 === void 0 ? void 0 : _this$rtc12.unsubscribe(id, 'audio');
        }
        this.$set(this.channels, payload.id, obj);
      } catch (error) {}
    },
    // 处理初始化及其他 audio-only 时的视频订阅问题
    dealSubscribeVideo(payload) {
      const _this = this;
      const {
        id
      } = payload;
      // 因为还没有后面赋值所以先添加上
      if (!this.channels[id]) {
        this.$set(this.channels, id, {
          id: id,
          channel: this.party
        });
      }
      const pinnCode = this.outputRtilCode || this.leftRightRtilCode;
      if (pinnCode && pinnCode == id) {
        // 先判断当前 audio-only 选择的模式
        if (this.State.audioType) {
          if (this.State.checkMainWindow || this.State.audioType == 2) {
            this.channels[id].hasUnsubscribe = false;
            this.dealLocalShareScreen(id, '', 'unExecuteCallback', true);
          } else {
            this.channels[id].hasUnsubscribe = true;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkMainWindow) {
              this.channels[id].hasUnsubscribe = false;
              this.dealLocalShareScreen(id, '', 'unExecuteCallback', true);
            } else {
              this.channels[id].hasUnsubscribe = true;
            }
          } else {
            this.channels[id].hasUnsubscribe = false;
            this.dealLocalShareScreen(id, '', 'unExecuteCallback', true);
          }
        }
      } else if (this.shareList[id]) {
        if (this.State.audioType) {
          if (this.State.checkShareScreen || this.State.audioType == 2) {
            this.channels[id].hasUnsubscribe = false;
            this.dealLocalShareScreen(id, '', 'unExecuteCallback', true);
          } else {
            this.channels[id].hasUnsubscribe = true;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkShareScreen) {
              this.channels[id].hasUnsubscribe = false;
              this.dealLocalShareScreen(id, '', 'unExecuteCallback', true);
            } else {
              this.channels[id].hasUnsubscribe = true;
            }
          } else {
            this.channels[id].hasUnsubscribe = false;
            this.dealLocalShareScreen(id, '', 'unExecuteCallback', true);
          }
        }
      } else {
        if (this.State.audioType == 1) {
          _this.channels[id].hasUnsubscribe = true;
        } else {
          this.dealLocalShareScreen(id, '', 'unExecuteCallback', true);
          this.channels[id].hasUnsubscribe = false;
        }
      }
    },
    cancelStopShare() {
      if (this.shareClient && this.shareClient._shareTrack) {
        if (this.shareClient._shareTrack instanceof Array) {
          this.shareClient._shareTrack.forEach(item => {
            item._mediaStreamTrack.stop();
          });
        } else {
          this.shareClient._shareTrack._mediaStreamTrack.stop();
        }
        this.shareClient && this.shareClient.leave();
      }
    },
    getVideoType(payload) {
      this.axios.post(`/partyline-backend/member/queryByRtilCode/${payload.id}`).then(res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          var _result$accountId;
          const result = res.data.result;
          const accountId = (_result$accountId = result.accountId) === null || _result$accountId === void 0 ? void 0 : _result$accountId.toLowerCase();
          const type = returnSourceType(result, this.outputRtilCode, payload.id);
          this.$set(this.rtilCodeKeyTypeVal, payload.id, type);
          if (type === 'T') {
            this.State.v3List.push(result);
          }
          // anywhereSetting设置
          if (type === 'Anywhere') {
            this.$set(this.anyWherePlatForms, payload.id, result.devicePlatform);
            this.$set(this.anyWherePeerIds, payload.id, result.devicePeerId);
            this.$set(this.isAnyWhere, payload.id, true);
          }
          this.$set(this.deviceType, payload.id, result.deviceType);
          this.$set(this.State.deviceTypeMap, payload.id, type);
          this.$set(this.devicePlatform, payload.id, result.devicePlatform);
          result.devicePeerId && this.$set(this.devicePeerIdInfo, result.devicePeerId, payload.id);
          // 判断是不是share的code,获取nickName
          let shareInitiator = '';
          let shareCode = '';
          const canSave = this.canSaveToGlobal(type, payload.id);
          if (canSave) {
            this.State.allRtilCodes.push(payload.id);
          }
          if (accountId.indexOf('_sharescreen') > -1) {
            // 获取是谁发起的share的code
            shareCode = payload.id;
            shareInitiator = accountId.split('_sharescreen')[0];
            this.$set(this.shareList, shareCode, shareInitiator);
            this.$set(this.rtilCodeByShare, shareInitiator, shareCode);
            this.getNickName(shareInitiator, payload.id);
            this.handleRtilCodeList();
            // 初始化时接口返回慢于 Agora 推送消息会导致显示 audio-only 状态
            const _this = this;
            if (this.channels[shareCode]) {
              if (this.State.audioType || this.State.audioType == 2) {
                if (_this.State.checkShareScreen) {
                  _this.channels[shareCode].hasUnsubscribe = false;
                  this.dealLocalShareScreen(shareCode, '', 'unExecuteCallback', true);
                }
              }
            }
          } else {
            this.getNickName(payload.id, '');
          }
          if ((result.rtilCodeType == 0 || result.rtilCodeType == 1) && !accountId.includes('_sharescreen') && !this.allPartyMembers.includes(payload.id)) {
            const allPartyMemberList = this.allPartyMembers;
            allPartyMemberList.push(payload.id);
            if (this.sttRtilCode) {
              this.allPartyMembers = allPartyMemberList.filter(rtilCode => {
                return rtilCode != this.sttRtilCode;
              });
            } else {
              this.allPartyMembers = allPartyMemberList;
            }
            // this.allPartyMembers.push(payload.id)
          }
          // 为了live时，找出rtilcode与account的一一对应关系
          if (!result.deviceType || type === 'R') {
            var _res$data$result$acco, _res$data$result$acco2;
            this.allRtilCodeByAccountId[(_res$data$result$acco = res.data.result.accountId) === null || _res$data$result$acco === void 0 ? void 0 : _res$data$result$acco.toLowerCase()] = payload.id;
            this.allAccountIdByRtilCode[payload.id] = (_res$data$result$acco2 = res.data.result.accountId) === null || _res$data$result$acco2 === void 0 ? void 0 : _res$data$result$acco2.toLowerCase();
          }
          if (result.deviceType === 'T' || type === 'R') {
            if (!this.sourceIdList.includes(accountId)) {
              this.sourceIdList.push(accountId);
            }
            if (!this.sourceIdKeyList.includes(accountId)) {
              this.sourceIdKeyList.push(accountId);
            }
          }
          if (type === 'R') {
            if (this.channels[payload.id]) {
              this.$set(this.channels[payload.id], 'devicePeerId', result.devicePeerId);
              this.$set(this.channels[payload.id], 'info', result);
            }
            this.$set(this.channels[payload.id], 'channel', payload.channel);
            if (this.outputRtilCode != payload.id) return;
            // test pgm video
            this.State.pgmStream = payload;
            this.selectPGMRid = accountId;
            this.lastPgm.id = this.selectPGMRid;
          }
          if (!this.State.deviceInfo[payload.id]) {
            this.$set(this.State.deviceInfo, payload.id, result);
          }
          let obj = Object.assign({}, this.channels[payload.id]);
          obj = {
            ...payload,
            ...obj,
            tid: accountId,
            info: result,
            shareInitiator,
            shareCode
          };
          this.$set(this.channels, payload.id, obj);
        }
      });
    },
    canSaveToGlobal(type, id) {
      let flag = true;
      if (type == 'R' || type == 'T' || this.sttRtilCode == id || this.outputRtilCode && this.outputRtilCode == id || this.State.allRtilCodes.includes(id)) {
        flag = false;
      }
      return flag;
    },
    getRtcStats({
      videoQuality
    }) {
      if (!this.rtc) return;
      if (videoQuality == 'high') {
        this.timer = setInterval(() => {
          const result = this.rtc.getRtcStats();
          if (result && result.OutgoingAvailableBandwidth) {
            const currentBitrate = result.OutgoingAvailableBandwidth;
            if (this.timer) clearInterval(this.timer);
            Object.keys(this.resolutionRange).forEach(key => {
              const v = this.resolutionRange[key];
              if (v.range[1] && currentBitrate > v.range[0] && currentBitrate <= v.range[1] || !v.range[1] && currentBitrate > v.range[0]) {
                this.rtc.setEncoderConfiguration(v);
              }
            });
          }
        }, 1000);
      } else {
        var _this$rtc13;
        (_this$rtc13 = this.rtc) === null || _this$rtc13 === void 0 ? void 0 : _this$rtc13.setEncoderConfiguration(this.resolutionRange['360p']);
      }
    },
    async getNickName(id, key, anywhereSetting) {
      if (!id || !this.partyCode && !this.State.partyCode) return;
      await this.axios.post('/partyline-backend/behavior/noLogin/getList', {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.partyCode || this.State.partyCode,
        keys: ['nickName', 'tagName', 'talkBack', 'camera', 'mic', 'blockAudio', 'blockVideo', 'voipRid', 'voipSourceId', 'flipVideo', 'voiceCommand', 'resolution', 'fps', 'resolutionOptions', 'fpsOptions', 'whiteBalance', 'whiteBalanceRange', 'cameraOptions', 'whiteBalancePredefined', 'lock', 'whiteBalanceAuto', 'cameraPosition', 'defaultView', 'autoFocus', 'focusDistance', 'focusDistanceRange', 'autoExposure', 'exposure', 'exposureRange', 'zoom', 'zoomRange', 'isSupportGimbal'],
        marks: [id]
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          // 1、分享画面在分享者之后加进来 直接去分享者nickname
          // 2、分享在分享之之前进来（刷新页面） 找到分享者并赋值
          const result = res.data.result[id];
          // mainwindow和与会者都需要set旋转度数
          this.$set(this.degreeHost, id, result.flipVideo);
          const rtilCode = key || id;
          this.$set(this.behaviorInfo, rtilCode, result.nickName);
          this.$set(this.State.globalNameInfo, rtilCode, result.nickName);
          if (id == this.userInfo.rtilCode && result.voipRid) {
            this.needStartVoip = true;
            this.$set(this.voipSourceIdList, id, result.voipSourceId);
          }
          this.$set(this.voipInfo, id, result.voipRid);
          this.$set(this.tagNameInfo, id, result.tagName);
          this.$set(this.talkBackInfo, id, result.talkBack === 'true');
          this.$set(this.anyWhereSettings, id, {
            fps: result.fps,
            resolution: result.resolution,
            whiteBalance: JSON.parse(result.whiteBalance),
            lock: result.lock,
            whiteBalanceAuto: result.whiteBalanceAuto,
            cameraPosition: result.cameraPosition,
            resolutionOptions: result.resolutionOptions,
            fpsOptions: result.fpsOptions,
            whiteBalanceRange: result.whiteBalanceRange,
            cameraOptions: result.cameraOptions,
            whiteBalancePredefined: result.whiteBalancePredefined,
            defaultView: result.defaultView,
            autoFocus: result.autoFocus,
            focusDistanceRange: result.focusDistanceRange,
            focusDistance: result.focusDistance ? result.focusDistance : 0,
            autoExposure: result.autoExposure,
            exposureRange: result.exposureRange,
            exposure: result.exposure ? result.exposure : 0,
            zoom: result.zoom ? result.zoom : 0,
            zoomRange: result.zoomRange,
            isSupportGimbal: result.isSupportGimbal
          });
          if (anywhereSetting) {
            this.anyWhereInfo.show = true;
          }
          // 判断 host 是否可以 voice command
          if (result.voiceCommand !== 'true' && id == this.userInfo.rtilCode) {
            this.State.voiceCommandList = this.State.voiceCommandList.filter(rtilCode => {
              return rtilCode != id;
            });
          }
        }
      }).catch(e => {
        console.log('getList failed');
      });
    },
    setNickName(obj) {
      this.joinPartyLine(obj);
    },
    async joinPartyLine(behaviors) {
      if (this.State.currentPartyInfo.coHost == 2) {
        this.asParticipant = false;
      }
      const params = {
        asParticipant: this.asParticipant,
        memberId: handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime(),
        partyCode: this.partyCode,
        role: 0,
        type: 2,
        host: true,
        behaviorKeyList: ['hearSelf', 'speaker', 'nickName', 'mic', 'camera', 'audioOnlyType', 'checkAudioMainWindow', 'checkAudioShare', 'flipVideo', 'summaryLanguage']
      };
      if (behaviors) params.behaviors = behaviors;
      this.axios.post('/partyline-backend/party/noLogin/join', params).then(async res => {
        if (res.data.errorCode === '0x0') {
          var _result$stt, _result$stt2, _this$rtc14, _result$stt3, _result$status, _result$status2, _status$shareMsg;
          const result = res.data.result;
          const {
            status,
            behavior
          } = result;
          this.rtilCode = result.rtilCode;
          this.pipHostVolume = status.pipVolume;
          this.getAllPrivate();
          if ((_result$stt = result.stt) !== null && _result$stt !== void 0 && _result$stt.outputRtilCode && (_result$stt2 = result.stt) !== null && _result$stt2 !== void 0 && _result$stt2.running) {
            this.getHistoryData(result);
          }
          addTabTitle({
            userInfo: result
          });
          // 判断登入账号是否为内部账号
          if ((_this$rtc14 = this.rtc) !== null && _this$rtc14 !== void 0 && _this$rtc14._AgoraRTC && JSON.stringify(this.State.checkEnv) != '{}' && this.State.checkEnv.userEmail.includes('tvunetworks') && process.env.NODE_ENV === 'production') {
            this.rtc._AgoraRTC.setLogLevel(0);
            this.rtc._AgoraRTC.enableLogUpload();
          }
          // 存旋转度数
          this.$set(this.degreeHost, result.rtilCode, behavior.flipVideo);
          // 为了 Audio Matrix 添加获取当前是否有静音人的数据
          await this.getMyselfMuteInfo(result);
          this.getAllAudioMatrixMute();
          this.userInfo = result;
          this.allPartyMembers.unshift(result.rtilCode);
          this.State.partyJoinInfo = result;
          this.State.aiBotEnable = status.voiceCommand;
          this.State.audioType = behavior.audioOnlyType ? Number(behavior.audioOnlyType) : 2;
          this.translateInto = behavior.summaryLanguage ? behavior.summaryLanguage : '';
          this.State.checkMainWindow = behavior.checkAudioMainWindow !== 'false';
          this.State.checkShareScreen = behavior.checkAudioShare !== 'false';
          this.State.audioMatrixEnable = status.audioMatrix;
          this.State.productionId = status.voiceCommandProduction;
          if (!this.State.voiceCommandList.includes(result.rtilCode)) {
            this.State.voiceCommandList.push(result.rtilCode);
          }
          if (this.State.hadLoadPartyList) {
            this.State.newPageLoading = false;
          }
          if (!this.State.allRtilCodes.includes(result.rtilCode)) {
            this.State.allRtilCodes.push(result.rtilCode);
          }
          if (status.pushToTalk) {
            this.State.pushTalkOpen = true;
            this.getAllGroup();
          }
          // 给cohsot提供流的名称
          this.State.participantRole = result.participantRole;
          Bus.$emit('changeAudioTypeVal');
          Bus.$emit('changeAudioMatrix', {
            host: status.audioMatrix,
            participant: status.participantAudioMatrix
          });
          // 控制host页面的hotJar
          Tool.showPipHotJar(result.status.hotJar !== 0);
          Tool.showChatlio(result.status.Chatlio !== 0);
          // 传递GalleryView模式下的初始化数据
          Bus.$emit('initOperateData', result.status);
          if (result.anywhereGlobalSetting) {
            Bus.$emit('getAnyWhereGlobalSetting', {
              defaultView: result.anywhereGlobalSetting.defaultView && JSON.parse(result.anywhereGlobalSetting.defaultView).display,
              lockScreen: result.anywhereGlobalSetting.lockScreen && JSON.parse(result.anywhereGlobalSetting.lockScreen).lock,
              resolutionFps: result.anywhereGlobalSetting.resolutionFps && JSON.parse(result.anywhereGlobalSetting.resolutionFps),
              switchCamera: result.anywhereGlobalSetting.switchCamera && JSON.parse(result.anywhereGlobalSetting.switchCamera).position
            });
          }
          result.status.volumeEffect === 0 ? this.audioLevel = true : this.audioLevel = false;
          result.status.disableTalkInvokeAm === 1 ? this.muteAmAudio = true : this.muteAmAudio = false;
          Bus.$emit('getCollaborateInfo');
          // 当party不是自己的时候，需要已参会者额身份加入
          const _this = this;
          if (!result.owner && _this.State.currentPartyInfo.coHost != 2 && _this.State.currentPartyInfo.coHost != -1) {
            this.$router.push({
              name: 'participate',
              query: {
                join_id: result.joinCode
              }
            });
            return;
          }
          this.joinParam = {
            ...result,
            memberId: params.memberId,
            partyCode: this.partyCode
          };
          // 存储host 登录过的标记
          handleLocalStorage('set', 'isHost', result.owner);
          // 获取talkback
          this.sttRtilCode = (_result$stt3 = result.stt) === null || _result$stt3 === void 0 ? void 0 : _result$stt3.outputRtilCode;
          this.State.allRtilCodes = this.State.allRtilCodes.filter(v => v != this.sttRtilCode);
          this.getNickName(result.rtilCode);
          this.talkbackStatus = ((_result$status = result.status) === null || _result$status === void 0 ? void 0 : _result$status.talkBack) === 'true';
          this.State.talkbackStatus = ((_result$status2 = result.status) === null || _result$status2 === void 0 ? void 0 : _result$status2.talkBack) === 'true';
          if (result.status.talkBackList) {
            result.status.talkBackList.forEach(v => {
              this.$set(this.controlMuteInfo, v.rtilCode, true);
            });
          }
          // 获取初始化的一些状态
          Bus.$emit('getInitStatus', {
            videoQuality: result.status.videoQuality || 'low',
            talkBack: this.talkbackStatus,
            cloudProxy: result.status.cloudProxy === 'true'
          });

          // 初始化live的对象,目的是拿到所有rtilCode的key值，在updataStatus()进行循环判断
          if (!this.rtilCodeLiveR[result.rtilCode]) {
            this.rtilCodeLiveR[result.rtilCode] = '';
          }
          this.allRtilCodeByAccountId[params.memberId] = result.rtilCode;
          this.allAccountIdByRtilCode[result.rtilCode] = params.memberId;
          if (behavior && behavior.nickName) {
            const nickName = behavior.nickName;
            behavior.speaker = behavior.speaker !== 'false';
            behavior.camera = behavior.camera !== 'false';
            behavior.mic = behavior.mic !== 'false';
            this.joinAgoraClient(result, behavior, this.joinParam);
            this.$set(this.behaviorInfo, this.userInfo.rtilCode, nickName);
            this.$set(this.State.globalNameInfo, this.userInfo.rtilCode, nickName);
          }

          // 清除share的状态
          if (status.outputSource == 'ShareScreen' && ((_status$shareMsg = status.shareMsg) === null || _status$shareMsg === void 0 ? void 0 : _status$shareMsg.initiator) == this.userInfo.rtilCode) {
            this.outputRtilCode = status.output;
            this.State.outputCode = status.output;
            this.stopShare({
              id: status.output
            });
            status.output = '';
            status.outputSource = '';
          }
          // 获取status里面的值
          // 记住初始化状态
          this.outputRtilCode = status.output;
          this.State.outputCode = status.output;
          this.startHearSelf = !!status.hearThemSelf;
          this.State.startHearSelf = !!status.hearThemSelf;
          this.hearSelf = behavior.hearSelf === 'true';
          this.State.intercom = 1;
          this.$refs.footDiv && this.$refs.footDiv.changeHearSelfValue(this.hearSelf);
          if (status.hearThemSelf) {
            this.iconList.forEach(item => {
              if (item === 'speaker') {
                this.iconList.push('hearMyself');
              }
            });
          }
          this.vfbSourceType = !status.outputSource || status.outputSource === 'Default' ? 'Live' : status.outputSource;
          this.lastPgm.type = this.vfbSourceType;
          this.getOnlineMember();
          status.hearThemSelf ? this.State.startHearSelf = true : '';
          Bus.$emit('initVFBinfo', status);
          // 是否要取消屏幕共享, 如果是调度者自己分享则需要取消，与会者分享保留状态
          this.isallScrren = false;
        } else if (res.data.errorCode === '80520111') {
          this.coHostLimit.show = true;
        }
      });
    },
    async joinAgoraClient(result, obj, param, notInitStatus) {
      if (!this.State.pageSerBusRequestWs[this.partyCode]) {
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode: this.partyCode
        });
      }
      // join到 Agora 会议需要准备的数据
      this.State.isMute = !obj.speaker;
      if (!notInitStatus) {
        this.$set(this.State.cameraStatus, result.rtilCode, this.devicesInfo.cameraId ? obj.camera : false);
        this.$set(this.State.micStatus, result.rtilCode, this.devicesInfo.microphoneId ? obj.mic : false);
      }
      // Me设置crew功能，使用到
      this.MeInfo = {
        id: result.rtilCode,
        tid: this.loginInfo.id,
        info: {
          rtilCode: result.rtilCode
        },
        channel: this.partyCode
      };
      this.State.currentRtilCode = result.rtilCode;
      handleLocalStorage('set', 'manageRtilCode', result.rtilCode);
      handleLocalStorage('set', 'rtilCode', result.rtilCode);
      // 发送状态
      // this.createdPartyLineRequest(this.partyCode, result.rtilCode)
      // join client
      this.getMeetingInfo(param, result);
    },
    async getMeetingInfo(param, result) {
      const {
        appId,
        tokenCode,
        rtilCode,
        partyCode,
        memberId,
        videoQualities
      } = param;
      const params = {
        appId: appId,
        channel: partyCode + '',
        token: tokenCode,
        uid: rtilCode,
        codec: 'h264',
        videoConfig: videoQualities,
        publishVideo: this.State.cameraStatus[this.userInfo.rtilCode],
        publishAudio: this.State.micStatus[this.userInfo.rtilCode],
        // 不能再根据当前是否有媒体设备来创建 track
        // 还要添加当前是否处于禁止状态
        // 极少数会出现 mute camera 了并且 camera 还被占了，这个时候创建会报错，而且会有即使 mute 了 camera 但是摄像头灯还在亮的问题
        video: !!this.devicesInfo.cameraId && this.State.cameraStatus[this.userInfo.rtilCode],
        audio: !!this.devicesInfo.microphoneId && this.State.micStatus[this.userInfo.rtilCode],
        getRemoteNetworks: true,
        // 传入用户选择的可用的音视频采集设备的id
        microphoneId: this.devicesInfo.microphoneId,
        cameraId: this.devicesInfo.cameraId,
        executeLocalSubscribe: true,
        startProxy: result.status.cloudProxy === 1
      };
      const uid = await this.rtc.join(params);
      // debugger
      if (uid) {
        this.hadOpenWebCloud = result.status.cloudProxy === 1;
        this.rtcLoaded = true;
        this.State.controlInfo = {
          ...params,
          memberId: memberId
        };

        // 更改hostjr userId
        const userId = rtilCode + '_' + this.behaviorInfo[this.MeInfo.id] + '_' + this.partyCode;
        this.rtc._client && this.rtc._client.enableAudioVolumeIndicator();
        window.hj && window.hj('identify', userId, {
          timeStamp: Date.now()
        });
      }
    },
    async callBack({
      action,
      payload
    }) {
      var _this$rtc15, _this$rtc16, _this$rtc17, _this$rtc$_localAudio, _this$rtc18, _this$rtc19, _this$rtc20;
      const {
        changeDevice
      } = payload;
      switch (action) {
        case 'voiceCheck':
          if (this.speechTimer) clearTimeout(this.speechTimer);
          this.State.aiSpeech.running = true;
          this.$refs.aiSpeech && this.$refs.aiSpeech.dealAiSpeechInfo(payload);
          this.speechTimer = setTimeout(() => {
            this.State.aiSpeech.running = false;
          }, 2000);
          break;
        case 'noCameras':
          this.noCameras = true;
          break;
        case 'unlinkQuality':
          this.unlinkQuality(payload);
          break;
        case 'changeDevice':
          if (payload.status === 'success') {
            handleLocalStorage('set', payload.type, payload.deviceId);
          }
          break;
        case 'user-joined':
          this.userJoin(payload);
          break;
        case 'user-left':
          this.userLeave(payload);
          break;
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
        case 'subscribe-video':
          this.dealSubscribeVideo(payload);
          break;
        case 'user-published':
        case 'user-unpublished':
          this.userPublished(action, payload);
          break;
        case 'stop-share':
          console.log('stop screen share by stop-share');
          this.stopShare(payload);
          break;
        case 'start-share':
          this.sendShareViewPosition(payload);
          break;
        case 'local-track':
          const {
            videoTrack,
            audioTrack
          } = payload;
          // Me设置私聊功能，使用到
          this.MeInfo = {
            id: this.userInfo.rtilCode,
            tid: handleLocalStorage('get', 'memberId'),
            info: {
              rtilCode: this.userInfo.rtilCode
            },
            channel: this.partyCode,
            videoTrack: videoTrack,
            audioTrack: audioTrack
          };
          this.MeInfos = {
            id: this.userInfo.rtilCode,
            tid: handleLocalStorage('get', 'memberId'),
            info: {
              rtilCode: this.userInfo.rtilCode
            },
            channel: this.partyCode,
            videoTrack: videoTrack
          };
          this.$set(this.channels, this.userInfo.rtilCode, this.MeInfos);
          if ((_this$rtc15 = this.rtc) !== null && _this$rtc15 !== void 0 && _this$rtc15._localVideoTrack) {
            const videoLabel = this.rtc._localVideoTrack.getTrackLabel();
            this.devicesInfo.cameraList.forEach(item => {
              if (item.label === videoLabel) {
                this.devicesInfo.cameraId = item.deviceId;
              }
            });
            if (this.noCamera) {
              controlCamera(this.rtc, this.devicesInfo, false);
              controlDeviceBehavior({
                senderRtilCode: this.userInfo.rtilCode,
                type: 'camera',
                value: false,
                partyCode: this.userInfo.realPartyCode,
                toRtilCode: this.userInfo.rtilCode,
                origin: 'commonPartyHost'
              });
            }
          }
          if ((_this$rtc16 = this.rtc) !== null && _this$rtc16 !== void 0 && _this$rtc16._localAudioTrack) {
            const audioLabel = this.rtc._localAudioTrack.getTrackLabel();
            this.devicesInfo.microphoneList.forEach(item => {
              if (item.label === audioLabel) {
                this.devicesInfo.microphoneId = item.deviceId;
              }
            });
            // 为了是否需要听见自己的声音添加的
            if (this.startHearSelf && this.hearSelf && this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
              this.rtc && this.rtc.play(this.rtc._localAudioTrack, '', {
                type: 'audio'
              });
            }
            this.detecteMicMuted();
          }
          break;
        case 'autoPlayFailed':
          this.$confirm(this.$t('commonFunction.autoPlayFailed'), {
            confirmButtonText: this.$t('galleryHost.ok'),
            cancelButtonText: this.$t('commonFunction.cancel'),
            customClass: 'confirmBox',
            cancelButtonClass: 'cancelBtn',
            confirmButtonClass: 'joinBtn'
          }).then(() => {
            this.rtc && this.rtc.rePlay();
          }).catch(e => {
            console.log(e);
          });
          break;
        case 'local-publish':
          if (payload.type.includes('audio') && this.userInfo.rtilCode) {
            this.$set(this.State.micStatus, this.userInfo.rtilCode, true);
          }
          if (payload.type.includes('video') && this.userInfo.rtilCode) {
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, true);
          }
          break;
        case 'local-unpublish':
          if (payload.type.includes('audio') && this.userInfo.rtilCode) {
            this.$set(this.State.micStatus, this.userInfo.rtilCode, false);
          }
          if (payload.type.includes('video') && this.userInfo.rtilCode) {
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, false);
          }
          break;
        case 'receiveMetadata':
          this.dealMetadata(payload);
          break;
        case 'connection-state-change':
          // 代表有人重复加入
          if (payload.reason === 'UID_BANNED') {
            this.repeatInfo.show = true;
          }
          break;
        case 'cameraChange':
          if (!this.rtc) return;
          this.devicesInfo = this.rtc && (await this.rtc.getDevice());
          if ((_this$rtc17 = this.rtc) !== null && _this$rtc17 !== void 0 && _this$rtc17._localVideoTrack && changeDevice.device.label === this.rtc._localVideoTrack.getTrackLabel()) {
            try {
              const oldCameras = await this.rtc._AgoraRTC.getCameras();
              oldCameras[0] && this.rtc.setDevice(oldCameras[0].deviceId, 'video', returnType => {
                this.devicesInfo.cameraId = oldCameras[0].deviceId;
                returnType === 'success' ? this.$message.success(this.$t('common.autoSwitchNewCameraSuccess')) : this.$message.error(this.$t('common.autoSwitchNewCameraFailed'));
              });
            } catch (e) {
              console.log('get camera list failed');
            }
          }
          break;
        case 'micChange':
          if (!this.rtc) return;
          this.devicesInfo = this.rtc && (await this.rtc.getDevice());
          console.log('devicesinfo', this.devicesInfo);
          if (((_this$rtc$_localAudio = this.rtc._localAudioTrack) === null || _this$rtc$_localAudio === void 0 ? void 0 : _this$rtc$_localAudio._config.microphoneId) != 'default') {
            this.$message.warning(this.$t('common.micListChange'));
          }
          // 拔掉mic
          if ((_this$rtc18 = this.rtc) !== null && _this$rtc18 !== void 0 && _this$rtc18._localAudioTrack && this.rtc._localAudioTrack._deviceName.includes(changeDevice.device.label)) {
            try {
              const currentMicList = await this.rtc._AgoraRTC.getMicrophones();
              if (!currentMicList.length) return;
              const isHaveDefault = currentMicList.find(item => item.deviceId === 'default');
              this.rtc.setDevice(isHaveDefault ? 'default' : currentMicList[0].deviceId, 'audio', returnType => {
                if (returnType === 'success') {
                  this.detecteMicMuted();
                  this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
                  this.$refs.localSingleSource.controlAudioChannel();
                } else {
                  this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
                }
                this.devicesInfo.microphoneId = isHaveDefault ? 'default' : currentMicList[0].deviceId;
                console.log('log: ', 'The microphone list has changed');
              });
            } catch (e) {
              console.log('get mic list failed');
            }
          } else if (changeDevice.state === 'ACTIVE' && (_this$rtc19 = this.rtc) !== null && _this$rtc19 !== void 0 && _this$rtc19._localAudioTrack && this.rtc._localAudioTrack._config.microphoneId == 'default') {
            // 如果当前使用的是 default 设备并且新加入的也是 default 设备，则切换到最新的 default 设备
            const newDeviceGroupId = changeDevice.device.groupId;
            const newDeviceIsDefault = this.devicesInfo.microphoneList.find(item => item.groupId === newDeviceGroupId && item.deviceId === 'default');
            if (newDeviceIsDefault.deviceId) {
              this.rtc.setDevice('default', 'audio', returnType => {
                if (returnType === 'success') {
                  this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
                  this.$refs.localSingleSource.controlAudioChannel();
                  this.detecteMicMuted();
                } else {
                  this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
                }
              });
            }
          }
          break;
        case 'playbackChange':
          if (!this.rtc) return;
          const currentSpeakerList = await this.rtc._AgoraRTC.getPlaybackDevices();
          if (changeDevice.state !== 'ACTIVE' && (_this$rtc20 = this.rtc) !== null && _this$rtc20 !== void 0 && _this$rtc20._localAudioTrack) {
            const currentDeviceId = handleLocalStorage('get', 'speakerId');
            const currentLabelArray = this.devicesInfo.speakerList.filter(item => item.deviceId == currentDeviceId);
            const haveUseDevice = currentSpeakerList.find(item => item.label == currentLabelArray[0].label);
            if (!haveUseDevice && currentSpeakerList[0]) {
              handleLocalStorage('set', 'speakerId', currentSpeakerList[0].deviceId);
              this.$nextTick(() => {
                this.rtilCodeList.forEach(rtilCode => {
                  if (this.$refs[`remoteSingleSource${rtilCode}`][0] && rtilCode != this.outputRtilCode) {
                    this.$refs[`remoteSingleSource${rtilCode}`][0].setSpeaker();
                  }
                });
              });
              this.devicesInfo.speakerId = currentSpeakerList[0].deviceId;
            }
          }
          this.devicesInfo.speakerList = currentSpeakerList;
          break;
        case 'changeCameraId':
          this.deviceInfo.cameraId = payload.deviceId;
          break;
      }
    },
    dealMetadata(payload) {
      const {
        metadataInfo
      } = payload;
      if (this.userInfo.status) {
        this.userInfo.status.forwardMetadata = true;
      }
      if (!this.State.outputCode || this.State.outputCode && this.State.outputCode != payload.id) return;
      if (this.userInfo.status && this.userInfo.status.forwardMetadata === true) {
        const info = JSON.parse(this.Uint8ArrayToString(metadataInfo));
        info.rtil = this.userInfo.rtilCode;
        info.vframe_pts = Date.now();
        this.rtc._client.sendMetadata(new TextEncoder().encode(JSON.stringify(info)), function (error) {
          if (error) console.log('sendMetadata', error);
        });
      } else {
        const obj = {};
        obj.rtil = this.userInfo.rtilCode;
        obj.vframe_pts = Date.now();
        this.rtc._client.sendMetadata(new TextEncoder().encode(JSON.stringify(obj)), function (error) {
          if (error) console.log('sendMetadata', error);
        });
      }
    },
    Uint8ArrayToString(fileData) {
      let dataString = '';
      for (let i = 0; i < fileData.length; i++) {
        dataString += String.fromCharCode(fileData[i]);
      }
      return dataString;
    },
    saveHearSelfBehavior(value) {
      if (!this.userInfo.realPartyCode || !this.userInfo.rtilCode) return;
      const params = [{
        mark: this.userInfo.rtilCode + '',
        annotation: this.userInfo.realPartyCode,
        key: 'hearSelf',
        value
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {
        if (!value) {
          this.hearSelf = false;
          this.$refs.footDiv.changeHearSelfValue(false);
        }
      });
    },
    sendShareViewPosition({
      channel,
      id,
      shareInfo
    }) {
      const obj = {
        id,
        videoTrack: shareInfo.videoTrack,
        audioTrack: shareInfo.audioTrack
      };
      this.$set(this.channels, id, obj);
      const params = {
        joinType: 1,
        // as mainwindow 不过目前尚未实现 , 2 as pip
        partyCode: channel,
        rtilCode: id
      };
      this.axios.post('/partyline-backend/party/noLogin/startShare', params);
    },
    unlinkQuality(payload) {
      if (!payload.type) return;
      this.$set(this.remoteNetWorks, payload.id, {
        uplinkNetworkQuality: payload.uplinkNetworkQuality,
        downlinkNetworkQuality: payload.downlinkNetworkQuality
      });
    },
    userPublished(action, payload) {
      this.muteAudioOrVideo(action, payload);
      const {
        id,
        mediaType
      } = payload;
      if (action == 'user-unpublished' && mediaType == 'video') {
        this.$set(this.channels, id, {
          ...this.channels[id],
          videoTrack: null
        });
      }
    },
    stopShare(payload, byClickShareIcon, notSendCommand) {
      this.isallScrren = false;
      if (this.shareList[payload.id] == this.userInfo.rtilCode) {
        this.shareRtilCode = '';
      }
      this.$delete(this.rtilCodeByShare, this.shareList[payload.id]);
      this.$delete(this.shareList, payload.id);
      if (!notSendCommand) this.cancelShareCommand(payload.id);
      if (byClickShareIcon) {
        this.cancelStopShare();
      }
      if (this.outputRtilCode == payload.id) {
        // this.sendCancelShareOutput(payload.id)
        this.outputRtilCode = null;
        this.outputSourceType = null;
      }
    },
    sendCancelShareOutput() {
      const params = {
        partyCode: this.partyCode
      };
      this.axios.post('/partyline-backend/commonParty/stopPushStream', params);
    },
    cancelShareCommand(id) {
      const params = {
        partyCode: this.partyCode,
        module: 'cancelShareScreen',
        origin: 'commonPartyHost',
        msg: {
          rtilCode: id
        }
      };
      if (!id) return;
      this.axios.post('/partyline-backend/party/noLogin/command?key=2055', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.leftRightShareRtilCode = '';
          this.State.shareRtilCode = '';
          this.State.commonHostLeftRight = false;
        }
      });
    },
    muteAudioOrVideo(action, payload) {
      const {
        id
      } = payload;
      if (action === 'user-unpublished') {
        if (payload.mediaType === 'video') {
          this.$set(this.State.cameraStatus, id, false);
        } else {
          this.$set(this.State.micStatus, id, false);
        }
      } else {
        if (payload.mediaType === 'video') {
          this.$set(this.State.cameraStatus, id, true);
        } else {
          this.$set(this.State.micStatus, id, true);
        }
      }
    },
    createdPartyLineRequest(partyCode, rtilCode) {
      const taskId = Tool.return32Str();
      if (!this.Config.urlInfo) return;
      const url = 'wss://' + this.Config.urlInfo.ccWebsocket + '/partyLineRequest?taskId=' + taskId + '&partyCode=' + partyCode + '&rtilCode=' + rtilCode;
      const _self = this;
      this.PartyLineRequest = Tool.createWs(url);
      this.updataStatusTimer = setInterval(() => {
        if (_self.PartyLineRequest && _self.PartyLineRequest.client.readyState === 1) {
          const params = {
            type: 'listCurrentDevice',
            module: 'listCurrentDevice',
            data: {
              partyCode,
              rtilCode
            }
          };
          _self.PartyLineRequest.send(params);
        }
      }, 1000);
    },
    checkScreen() {
      this.isallScrren = false;
      Bus.$emit('changeAllScreen', this.isallScrren);
    },
    createdWebsocket(addressInfo) {
      const [taskId] = [Tool.return32Str()];
      if (!addressInfo.urlInfo) return;
      const url = 'wss://' + addressInfo.urlInfo.ccWebsocket + '/pageRequest?taskId=' + taskId;
      const _self = this;
      this.socket = Tool.createWs(url);
      this.updataInfoTimer = setInterval(() => {
        if (_self.socket.client.readyState === 1) {
          const params = {
            type: 'listCurrentDevice',
            module: 'listCurrentDevice',
            data: {
              peerIds: _self.sourceIdList
              // .concat(_self.State.slotList.map(item => item.rid))
              // .concat(_self.State.ccIdList)
              .join(',')
            }
          };
          _self.socket.send(params);
        }
      }, 1000);
    },
    changeMute(flag) {
      this.$store.commit('isMute', !this.State.isMute);
      if (flag) {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOff')
        });
      } else {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOn')
        });
      }
      // 判断是否需要恢复声音
      if (this.startHearSelf && this.hearSelf && this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
        this.rtc && this.rtc.play(this.rtc._localAudioTrack, '', {
          type: 'audio'
        });
      }
      changeBehaviorStatus({
        key: 'speaker',
        rtilCode: this.userInfo.rtilCode,
        realPartyCode: this.userInfo.realPartyCode,
        value: !this.State.isMute
      });
    },
    userLeave(payload) {
      this.State.haveUnReadMessage = true;
      // this.reportUserChange(payload, 'removeView')
      const {
        id
      } = payload;
      this.$delete(this.rtilCodeKeyTypeVal, id);
      if (this.State.localShareInfo[id]) this.$delete(this.State.localShareInfo, id);
      if (id == this.outputRtilCode) {
        this.State.pgmStream = null;
        this.origin = '';
        this.outputRtilCode = '';
      }
      if (payload.id == this.leftRightShareRtilCode) {
        this.leftRightShareRtilCode = '';
        this.State.commonHostLeftRight = false;
      }
      if (payload.id == this.leftRightRtilCode) {
        this.leftRightRtilCode = '';
        this.State.commonHostLeftRight = false;
      }
      if (this.shareList[payload.id]) {
        this.stopShare(payload, '', 'notSendCommand');
      }
      if (this.fullScreenInfo[payload.id]) {
        this.$set(this.fullScreenInfo, id, false);
        this.State.fullScreen = false;
        if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
          document.exitFullscreen();
        }
      }
      this.State.v3List.forEach((item, index) => {
        if (item.rtilCode == payload.id && item.type === 'T') {
          this.State.v3List.splice(index, 1);
        }
      });
      // chat人员
      this.allPartyMembers = this.allPartyMembers.filter(v => v != payload.id);
      this.$set(this.channels, id, {
        id
      });
      this.$delete(this.State.deviceInfo, id);
      this.$delete(this.allAccountIdByRtilCode, id);
      this.State.allRtilCodes = this.State.allRtilCodes.filter(v => v != payload.id);
      // 更新所有可以moveParty的rtilCode
      this.State.batchMoveParticipateList = this.State.batchMoveParticipateList.filter(v => v != payload.id);
      // 如果当前弹窗开着需要关闭
      if (id == this.anyWhereInfo.rtilCode) {
        this.anyWhereInfo.show = false;
        this.$set(this.anywhereSettingShowMap, this.anyWhereInfo.rtilCode, false);
        this.anyWhereInfo.rtilCode = '';
        this.anyWhereVideoAudioInfo = null;
        this.$message.success(this.$t('anywhereSetting.userLeft'));
      }
    },
    reportUserChange({
      channel,
      id
    }, type) {
      this.axios.post('/partyline-backend/party/noLogin/reportUserChange', {
        partyCode: channel,
        addRtilCodes: type === 'addView' ? [id] : [],
        removeRtilCodes: type === 'removeView' ? [id] : []
      });
    },
    changeSourceList(ccRlist) {
      ccRlist.forEach((item, index) => {
        if (!this.sourceIdKeyList.includes(item.peerId)) {
          this.sourceIdList.push(item.peerId);
        }
      });
    },
    updateSourceData(obj) {
      if (obj.type == 'showEncoderInfo') {
        const array = [];
        obj.val.encoders.forEach(item => {
          var _this$ChannelMode$ite;
          const object = {};
          object.code = item.code;
          object.title = item.title ? item.title : new Date(item.createTime).toLocaleDateString() + ' ' + new Date(item.createTime).toLocaleTimeString();
          object.mode = this.ChannelMode[item.mode] ? (_this$ChannelMode$ite = this.ChannelMode[item.mode]) === null || _this$ChannelMode$ite === void 0 ? void 0 : _this$ChannelMode$ite.toLowerCase() : '';
          object.email = item.loginUser.email;
          object.loading = false;
          array.push(object);
        });
        this.encoderInfo.maxNumber = obj.val.maxEncoderNumber;
        this.encoderInfo.data = array;
        this.encoderInfo.visible = true;
        return;
      }
      if (!obj.type) {
        this.vfbSourceType = this.lastPgm.type;
        this.selectPGMRid = this.lastPgm.id;
        return;
      }
      this.vfbSourceType = obj.type;
      this.lastPgm.id = obj.rId;
      this.lastPgm.type = obj.type;
    },
    setEnabledFn(value, type, origin, id, autoSwitch) {
      this.rtc && this.rtc.setEnabled(value, type, info => {
        if (info === 'failed') {
          this.$message.warning(this.$t('common.operationFailed'));
        } else {
          if (type == 'audio') {
            var _this$rtc21;
            // 为了可以听见自己声音的功能添加的
            if (this.State.startHearSelf && this.hearSelf && id == this.userInfo.rtilCode && (_this$rtc21 = this.rtc) !== null && _this$rtc21 !== void 0 && _this$rtc21._localAudioTrack) {
              this.rtc.play(this.rtc._localAudioTrack, '', {
                type: 'audio'
              });
            }
            this.changeBehaviorStatus('mic', value, autoSwitch);
            if (origin == 'host') {
              // message更换为弹窗
              if (value) {
                this.CameraTips.hideCancel = true;
                this.CameraTips.hideSave = true;
                this.CameraTips.showGotIt = true;
                this.CameraTips.show = true;
                this.CameraTips.content = `<div class="end">${this.$t('remainWords.hostHasMicrophoneOn')}</div>`;
              } else {
                this.CameraTips.hideCancel = true;
                this.CameraTips.hideSave = true;
                this.CameraTips.showGotIt = true;
                this.CameraTips.show = true;
                this.CameraTips.content = `<div class="end">${this.$t('commonFunction.hasMicrophoneOff')}</div>`;
              }
            }
          }
        }
      }, {
        controlsMedia: value
      });
    },
    async operateCallback(obj) {
      let {
        type,
        id,
        val,
        pipInfo
      } = obj;
      if (type == 'muteVideo') {
        if (id == this.userInfo.rtilCode) {
          if (val && this.State.anAvailbleDeviceId) {
            this.State.showInitCameraTips = true;
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, true);
          } else {
            controlCamera(this.rtc, this.devicesInfo, val);
          }
        }
        if (this.rtilCodeKeyTypeVal[id] && (this.rtilCodeKeyTypeVal[id] == 'T' || this.rtilCodeKeyTypeVal[id] == 'R')) {
          const info = {
            partyCode: this.userInfo.joinCode,
            rtilCode: id,
            value: val,
            type: 'video'
          };
          controlDeviceAudioOrVideo(info);
          return;
        }
        const params = {
          senderRtilCode: this.userInfo.rtilCode,
          type: 'camera',
          value: val,
          partyCode: this.userInfo.realPartyCode,
          toRtilCode: id,
          origin: 'commonPartyHost'
        };
        controlDeviceBehavior(params);
      } else if (type === 'muteAudio') {
        if (id == this.userInfo.rtilCode) {
          let operationResult = 'success';
          if (this.rtc._localAudioTrack) {
            const type = val ? 'publish' : 'unpublish';
            operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
          } else {
            // 初始化的时候没有本地音频轨道，需要重新获取
            controlAudio(this.rtc, this.devicesInfo, val, result => {
              if (result == 'failed') operationResult = 'failed';
            });
          }
          if (operationResult === 'success') {
            controlDeviceBehavior({
              senderRtilCode: this.userInfo.rtilCode,
              type: 'mic',
              value: val,
              partyCode: this.userInfo.realPartyCode,
              toRtilCode: this.userInfo.rtilCode,
              origin: 'commonPartyHost'
            });
            // 恢复听自己声音功能
            if (val && this.hearSelf && this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
              this.rtc && this.rtc.play(this.rtc._localAudioTrack, '', {
                type: 'audio'
              });
            }
          }
        } else {
          if (this.rtilCodeKeyTypeVal[id] && (this.rtilCodeKeyTypeVal[id] == 'T' || this.rtilCodeKeyTypeVal[id] == 'R')) {
            const info = {
              partyCode: this.userInfo.joinCode,
              rtilCode: id,
              value: val,
              type: 'audio'
            };
            controlDeviceAudioOrVideo(info);
            return;
          }
          controlDeviceBehavior({
            senderRtilCode: this.userInfo.rtilCode,
            type: 'mic',
            value: val,
            partyCode: this.userInfo.realPartyCode,
            toRtilCode: id,
            origin: 'commonPartyHost'
          });
        }
      } else if (type == 'editTagName') {
        this.editTagName(obj);
      } else if (type == 'moveParty') {
        id = String(id);
        const _this = this;
        this.$set(this.movePartyInfo, 'isIncludePack', false);
        if (obj.sign == 'batch') {
          // 批量
          if (obj.status) {
            if (!_this.batchMovePartyInfo.rtilCodes.includes(id)) {
              _this.batchMovePartyInfo.rtilCodes.push(id);
            }
          } else {
            this.batchMovePartyInfo.rtilCodes = this.batchMovePartyInfo.rtilCodes.filter(v => v != id);
          }
          _this.State.v3List.forEach(item => {
            if (_this.batchMovePartyInfo.rtilCodes.includes(item.rtilCode + '')) {
              _this.$set(this.movePartyInfo, 'isIncludePack', true);
            }
          });
        } else {
          this.movePartyInfo.show = true;
          this.movePartyInfo.rtilCodes = [String(id)];
          this.State.v3List.forEach(item => {
            if (this.movePartyInfo.rtilCodes.includes(item.rtilCode + '')) {
              this.$set(this.movePartyInfo, 'isIncludePack', true);
            }
          });
        }
      } else if (type == 'startPrivateConversation' || type == 'cancelPrivateConversation') {
        this.privateConversationFn(obj, 'sendRemark');
      } else if (type === 'fullScreen') {
        this.State.fullScreen = val;
        this.$set(this.fullScreenInfo, id, val);
        if (val) {
          var _document, _document$documentEle, _document$documentEle2;
          // this.$refs.commonPartyBox.requestFullscreen()
          (_document = document) === null || _document === void 0 ? void 0 : (_document$documentEle = _document.documentElement) === null || _document$documentEle === void 0 ? void 0 : (_document$documentEle2 = _document$documentEle.requestFullscreen) === null || _document$documentEle2 === void 0 ? void 0 : _document$documentEle2.call(_document$documentEle);
        }
      } else if (type == 'switchFullScreen') {
        if (!val && pipInfo.id == this.leftRightRtilCode && this.rtc && pipInfo.id != this.outputRtilCode && !this.shareList[pipInfo.id] && this.State.audioType == 1) {
          this.dealLocalShareScreen(pipInfo.id, 'needControlPlay', 'unExecuteCallback', false);
          this.channels[pipInfo.id].hasUnsubscribe = true;
        }
        if (pipInfo.id == this.outputRtilCode) {
          this.leftRightShareRtilCode = '';
        } else {
          val ? this.leftRightShareRtilCode = pipInfo.id : this.leftRightShareRtilCode = '';
        }
        this.leftRightRtilCode = val ? pipInfo.id : '';
        this.State.commonHostLeftRight = val;
        this.handleRtilCodeList();
        // 延迟为了防止结构没有加载
        const _this = this;
        setTimeout(() => {
          var _this$$refs$pgm;
          (_this$$refs$pgm = _this.$refs.pgm) === null || _this$$refs$pgm === void 0 ? void 0 : _this$$refs$pgm.changeFullScreenVal(val);
          if (pipInfo.id == this.leftRightRtilCode && this.rtc && val && (!this.shareList[pipInfo.id] && this.State.checkMainWindow || this.shareList[pipInfo.id] && this.State.checkShareScreen)) {
            this.dealLocalShareScreen(pipInfo.id, '', 'unExecuteCallback', true);
            this.channels[pipInfo.id].hasUnsubscribe = false;
          }
        }, 500);
      } else if (type === 'changeParticipantMedia') {
        if (!this.rtcLoaded) {
          this.$t('commonPartyHost.switchDeviceFailed');
          return;
        }
        const params = {
          partyCode: this.State.partyCode,
          module: 'notify',
          msg: {
            key: 'changeParticipantMedia',
            rtilCode: id,
            origin: 'host',
            type: val.type,
            deviceId: val.deviceId,
            email: this.State.loginInfo.userName
          }
        };
        this.axios.post('/partyline-backend/party/noLogin/command?key=27994', params).then(async res => {
          if (!this.allowedList[id]) {
            this.$message.success(this.$t('common.sendMediaRequest'));
          }
          // 同步更新下拉框所选择的内容
          Object.keys(this.otherMediaInfo).forEach(listRtilCode => {
            if (listRtilCode == val.rtilCode) {
              if (val.type === 'video') {
                this.$set(this.otherMediaInfo[listRtilCode], 'cameraId', val.deviceId);
              } else {
                this.$set(this.otherMediaInfo[listRtilCode], 'microphoneId', val.deviceId);
              }
            }
          });
        });
      } else if (type === 'audioContext') {
        this.localVolume = val;
      } else if (type === 'setting') {
        this.deviceDetailInfo.show = true;
        this.detailObj = obj;
      } else if (type === 'anyWhereSetting') {
        this.getNickName(id, '', 'anyWhereSetting');
        this.anyWhereInfo.rtilCode = id;
        this.anyWhereRtilCodeObj = this.channels[id];
        // 置空打开anyWhereSetting弹窗对应的列表流
        this.$set(this.channels, id, {});
        setTimeout(() => {
          this.$set(this.anywhereSettingShowMap, id, true);
        }, 500);
        this.anyWhereVideoAudioInfo = {
          rtilCode: id,
          id: id
        };
        if (this.rtc._subscribeTrack[id]) {
          const obj = Object.assign({}, this.channels[id]);
          obj.id = id;
          obj.videoTrack = this.rtc._subscribeTrack[id].videoTrack;
          obj.audioTrack = this.rtc._subscribeTrack[id].audioTrack;
          this.anyWhereVideoAudioInfo = obj;
        }
      } else if (type === 'mainwindow') {
        this.controlMainwindow(id);
      } else if (type === 'unMainwindow') {
        if (this.outputRtilCode == id) {
          this.outputRtilCode = '';
          if (!this.rtilCodeList.includes(id)) {
            this.State.commonHostLeftRight = false;
          }
        }
        this.controlMainwindow();
      } else if (type === 'dobuleClick') {
        if (this.outputRtilCode == id && !this.rtilCodeList.includes(id)) {
          this.State.commonHostLeftRight = false;
        }
        this.controlMainwindow(!this.outputRtilCode || this.outputRtilCode != id ? id : null);
      }
    },
    controlMainwindow(rtilCode) {
      if (!this.partyCode) return;
      if (!rtilCode) this.outputRtilCode = '';
      const params = {
        partyCode: this.partyCode,
        rtilCode: rtilCode
      };
      this.axios.post(`/partyline-backend/partyAction/setOutput?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }
      });
    },
    async privateConversationFn(obj, sendRemark) {
      const {
        type,
        rtilCode,
        channel,
        hostRtilCode,
        ack
      } = obj;
      if (!channel) return;
      // 开启talkback，无法私聊
      if (this.talkbackStatus && (this.talkBackInfo[rtilCode] || this.talkBackInfo[this.userInfo.rtilCode])) {
        this.$message.warning(this.$t('commonFunction.participantTips'));
        return;
      }
      if (this.State.pushTalkOpen) {
        this.$message.warning(this.$t('commonFunction.pushTalkTips'));
        return;
      }
      const params = {
        partyCode: channel,
        rtilCode: hostRtilCode || this.userInfo.rtilCode,
        startRtilCode: sendRemark && !this.sendPrivateToMeRtilcodes.includes(rtilCode) ? hostRtilCode || this.userInfo.rtilCode : '',
        receiveRtilCode: rtilCode,
        msg: {
          ack: sendRemark ? 0 : ack
        },
        value: type == 'startPrivateConversation'
      };
      this.axios.post('/partyline-backend/intercom/noLogin/i', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const nickName = this.behaviorInfo[rtilCode];
          if (params.startRtilCode && type == 'startPrivateConversation' && sendRemark) {
            this.$message({
              type: 'success',
              message: this.$t('commonPartyHost.sendTwoWayPrivate', {
                nickName
              })
            });
          } else if (!params.startRtilCode && type == 'startPrivateConversation' && params.msg.ack != 1) {
            this.$message({
              type: 'success',
              message: this.$t('commonPartyHost.sendOneWayPrivate', {
                nickName
              })
            });
          } else if (!params.startRtilCode && type == 'cancelPrivateConversation' && params.msg.ack != 1) {
            this.$message({
              type: 'success',
              message: this.$t('commonPartyHost.endOneWayPrivate', {
                nickName
              })
            });
          }
        }
      });
    },
    changeBehaviorStatus(key, value, id) {
      // 更新状态
      if (id == 'autoSwitch' || !id || !this.userInfo.rtilCode || !this.userInfo.realPartyCode) return;
      const params = [{
        mark: this.userInfo.rtilCode + '',
        annotation: this.userInfo.realPartyCode,
        key,
        value,
        notify: true
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {
        if (res.data.errorCode == '0x0') {
          if (key == 'speaker') {
            this.userInfo.behavior.speaker = value;
          }
        }
      });
    },
    shareScreen(shareType) {
      //  先判断当前是否为自己停掉 shareScreen
      if (shareType === 'stopShare') {
        this.stopShare({
          id: this.shareRtilCode
        }, 'byClickShareIcon');
        return;
      }
      const params = {
        memberId: `${this.userInfo.rtilCode}_sharescreen`,
        partyCode: this.partyCode,
        role: 0,
        type: 3,
        host: true,
        whetherSendViewPosition: 0 // 不推送viewPosition
      };

      this.axios.post('/partyline-backend/party/noLogin/join', params, {
        errorTip: false
      }).then(async res => {
        if (res.data.errorCode === '0x0') {
          const {
            appId,
            tokenCode,
            rtilCode,
            status
          } = res.data.result;
          const temp = {
            appId,
            channel: this.partyCode + '',
            token: tokenCode,
            uid: rtilCode,
            share: true,
            subscribeRemote: false,
            status
          };
          this.$set(this.behaviorInfo, rtilCode, this.behaviorInfo[this.userInfo.rtilCode]);
          this.$set(this.State.globalNameInfo, rtilCode, this.behaviorInfo[this.userInfo.rtilCode]);
          this.$set(this.shareList, rtilCode, this.userInfo.rtilCode);
          this.shareRtilCode = rtilCode;
          this.State.shareRtilCode = rtilCode;
          this.$set(this.State.localShareInfo, rtilCode, this.userInfo.rtilCode);
          this.shareClient = new AgoraClient(this.callBack);
          await this.shareClient.join(temp); // 初始化视频流
          this.saveShareName(res.data.result);
        }
      });
    },
    saveShareName({
      rtilCode
    }) {
      if (!rtilCode) return;
      const params = [{
        mark: String(rtilCode),
        annotation: this.partyCode + '',
        key: 'nickName',
        notify: true,
        value: this.behaviorInfo[this.MeInfo.id] + '_Screen_Share',
        initiator: String(rtilCode)
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {});
    },
    showV3List() {
      this.drawer = true;
    },
    clearStatus() {
      this.talkbackStatus = false;
      this.State.talkbackStatus = false;
      this.talkBackInfo = {};
    },
    switchDevice(obj) {
      if (obj.type == 'speaker') {
        handleLocalStorage('set', 'speakerId', obj.deviceId);
        // mainWindow
        if (this.outputRtilCode) {
          this.$refs.pgmBox && this.$refs.pgmBox.setSpeakerAttendUser();
        }
        // 与会者
        this.$nextTick(() => {
          this.rtilCodeList.forEach(rtilCode => {
            if (this.$refs[`remoteSingleSource${rtilCode}`][0] && rtilCode != this.outputRtilCode) {
              this.$refs[`remoteSingleSource${rtilCode}`][0].setSpeaker();
            }
          });
        });
      }
      this.rtc.setDevice(obj.deviceId, obj.type, result => {
        if (obj.type == 'audio' && result === 'success') {
          try {
            this.$refs.localSingleSource.controlAudioChannel();
            this.$message.success(this.$t('common.switchMicSuccess'));
            this.detecteMicMuted();
          } catch (e) {
            this.$message.warning(this.$t('common.switchMicFailed'));
            console.log(e);
          }
        }
        if (obj.type === 'video' && result === 'success' && !this.State.cameraStatus[this.rtilCode]) {
          var _this$rtc22;
          ((_this$rtc22 = this.rtc) === null || _this$rtc22 === void 0 ? void 0 : _this$rtc22._localVideoTrack) && this.rtc._localVideoTrack.setEnabled(false);
        }
      }, '', 'hostControl');
      this.sendToHostChange(obj.deviceId, obj.type);
    },
    sendToHostChange(deviceId, type) {
      const params = {
        partyCode: this.State.partyCode,
        module: 'notify',
        msg: {
          key: 'changeMediaInfo',
          rtilCode: this.rtilCode,
          type,
          deviceId
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=27994', params).then(async res => {});
    },
    throwError() {
      throw new Error('Test Sentry Error');
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.rtc) {
      this.rtc.leave(this.hadOpenWebCloud ? 'closeCLoudProxy' : '');
    }
    Bus.$off('downlinkNetworkQuality');
    if (this.canvasVideoTimer) clearInterval(this.canvasVideoTimer);
    this.socket && this.socket.close();
    this.PartyLineRequest && this.PartyLineRequest.close();
    this.State.pageSerBusRequestWs[this.partyCode] && this.State.pageSerBusRequestWs[this.partyCode].close();
    this.$delete(this.State.pageSerBusRequestWs, this.partyCode);
    this.shareClient && this.shareClient.leave();
    if (this.wsPageSTimer) clearInterval(this.wsPageSTimer);
    if (this.timer) clearInterval(this.timer);
    if (this.updataStatusTimer) clearInterval(this.updataStatusTimer);
    this.State.v3List = [];
    this.userInfo = {};
    if (this.setTimer) clearTimeout(this.setTimer);
    if (this.rtilStatusTimer) clearInterval(this.rtilStatusTimer);
    window.removeEventListener('resize', this.changeLayout);
    window.removeEventListener('keydown', this.listenerKeyDown);
    window.removeEventListener('keyup', this.listenerKeyUp);
    if (this.State.volumeBar) this.State.volumeBar.destroyAudioContext();
    next();
  }
};